# 创建日程管理主页面
<template>
  <div class="schedule-container">
    <div class="schedule-header flex items-center justify-between mb-4">
      <div class="schedule-title text-xl font-bold">
        <el-button icon="el-icon-arrow-left" type="text" size="medium" @click="goBack">返回归档管理</el-button>
        <template v-if="archiveName">
          <strong>{{ archiveName }}</strong> - 
        </template>
        日程矩阵视图
      </div>
      <div class="schedule-actions flex">
        <el-button type="primary" @click="openAddScheduleDialog">添加日程</el-button>
        <el-button type="success" @click="openThemeDialog" style="margin-left: 10px;">
          <i class="el-icon-brush"></i> 主题设置
        </el-button>
      </div>
    </div>

    <div class="schedule-content">
      <el-card shadow="never" class="mb-4">
        <!-- 顶部筛选条件区域 -->
        <div class="filter-tabs mb-4">
          <!-- 日期筛选 -->
          <div class="filter-group">
            <div class="filter-label">日期</div>
            <div class="filter-options">
              <el-button size="small" :type="!selectedDateId ? 'primary' : ''" @click="handleDateFilter('')">全部</el-button>
              <div 
                v-for="date in matrixData.dates" 
                :key="date._id"
                class="filter-button-wrapper"
              >
                <el-button 
                  size="small"
                  :type="selectedDateId === date._id ? 'primary' : ''"
                  @click="handleDateFilter(date._id)"
                >
                  {{ formatDateDisplay(date.date, 'MM-DD') }}{{ date.name ? ` (${date.name})` : '' }}
                </el-button>
                <div class="filter-button-actions">
                  <el-button 
                    type="text" 
                    icon="el-icon-edit" 
                    class="action-btn" 
                    @click.stop="handleEditDate(date)"
                  ></el-button>
                  <el-button 
                    type="text" 
                    icon="el-icon-delete" 
                    class="action-btn delete-btn" 
                    @click.stop="handleDeleteDate(date)"
                  ></el-button>
                </div>
              </div>
              <el-button size="small" icon="el-icon-plus" @click="openAddDateDialog">添加</el-button>
            </div>
          </div>
          
          <!-- 会场筛选 -->
          <div class="filter-group">
            <div class="filter-label">会场</div>
            <div class="filter-options">
              <el-button size="small" :type="!selectedVenueId ? 'primary' : ''" @click="handleVenueFilter('')">全部</el-button>
              <div 
                v-for="venue in matrixData.venues" 
                :key="venue._id"
                class="filter-button-wrapper"
              >
                <el-button 
                  size="small"
                  :type="selectedVenueId === venue._id ? 'primary' : ''"
                  @click="handleVenueFilter(venue._id)"
                >
                  {{ venue.name }}
                </el-button>
                <div class="filter-button-actions">
                  <el-button 
                    type="text" 
                    icon="el-icon-edit" 
                    class="action-btn" 
                    @click.stop="handleEditVenue(venue)"
                  ></el-button>
                  <el-button 
                    type="text" 
                    icon="el-icon-delete" 
                    class="action-btn delete-btn" 
                    @click.stop="handleDeleteVenue(venue)"
                  ></el-button>
                </div>
              </div>
              <el-button size="small" icon="el-icon-plus" @click="openAddVenueDialog">添加</el-button>
            </div>
          </div>

        </div>

        <div class="filter-container flex items-center justify-between mb-4 flex-wrap">
          <div class="filter-left flex items-center flex-wrap">
            <el-input
              v-model="keywordSearch"
              placeholder="搜索日程标题/主题"
              clearable
              class="w-48 mr-4 mb-2"
              @keyup.enter="getScheduleMatrix"
            >
              <el-button 
                slot="append" 
                icon="el-icon-search" 
                @click="getScheduleMatrix"
              ></el-button>
            </el-input>

            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="w-80 mr-4 mb-2"
              @change="getScheduleMatrix"
            />
          </div>
          
          <div class="filter-right flex items-center flex-wrap mb-2">
            <el-button type="primary" plain icon="el-icon-refresh" @click="getScheduleMatrix" class="action-btn">刷新</el-button>
            <el-button type="success" plain icon="el-icon-message" @click="openSmsDialog" class="action-btn">发送短信</el-button>
            <!-- <el-button type="primary" plain icon="el-icon-message" @click="openEmailDialog" class="action-btn">发送邮件</el-button> -->
            
            <div class="toolbar-actions">
              <!-- <el-button type="primary" plain icon="el-icon-download" @click="exportTemplate" class="action-btn">下载模板</el-button> -->
              <el-button type="primary" plain icon="el-icon-upload2" @click="openImportDialog" class="action-btn">导入Excel</el-button>
              <el-button type="primary" plain icon="el-icon-upload2" @click="exportExcel" class="action-btn">导出Excel</el-button>
            </div>
            <!-- <el-upload
              ref="uploadRef"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :data="{ archiveId }"
              :show-file-list="false"
              :before-upload="handleBeforeUpload"
              :on-progress="handleUploadProgress"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              accept=".xlsx,.xls"
              class="upload-component" 
            >
              <el-button type="primary" plain :loading="isUploading" class="action-btn">
                <i v-if="!isUploading" class="el-icon-upload2"></i>
                {{ isUploading ? `导入中 ${uploadProgress}%` : '导入Excel' }}
              </el-button>
            </el-upload> -->
          </div>
        </div>

        <!-- 加载中状态 -->
        <div v-if="loading" class="w-full flex justify-center items-center py-8">
          <div class="loading-skeleton">
            <div v-for="i in 6" :key="i" class="skeleton-row"></div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-else-if="!matrixData.dates || matrixData.dates.length === 0" class="empty-block">
          <el-empty description="暂无日程数据">
            <!-- 移除了所有按钮 -->
          </el-empty>
        </div>

        <!-- 矩阵视图 - 重新设计为时间为横坐标 -->
        <div v-else class="schedule-matrix">
          <div class="matrix-header flex">
            <div class="matrix-cell venue-header border-r bg-gray-100 flex items-center justify-center">
              场馆 / 日期
            </div>
            <div 
              v-for="date in matrixData.dates" 
              :key="date._id"
              class="matrix-cell date-header border-r bg-gray-100 p-2 text-center"
            >
              <div class="font-medium">{{ formatDateDisplay(date.date, 'MM-DD') }}</div>
              <div class="text-xs">{{ date.name || '日程' }}</div>
            </div>
          </div>

          <div class="matrix-body">
            <div 
              v-for="venue in matrixData.venues" 
              :key="venue._id"
              class="matrix-row flex"
            >
              <div class="matrix-cell venue-name border-r bg-gray-50 p-2 flex flex-col justify-center">
                <div class="font-medium">{{ venue.name }}</div>
                <div v-if="venue.image" class="venue-thumbnail">
                  <img :src="venue.image" alt="会场引导图" class="venue-img" />
                </div>
                <div v-else class="text-xs text-gray-500">无引导图</div>
              </div>

              <div 
                v-for="date in matrixData.dates" 
                :key="`${venue._id}-${date._id}`"
                class="matrix-cell content-cell relative p-1 border-r overflow-hidden"
                :class="{'bg-gray-50': isOddRow(venue._id)}"
              >
                <div v-if="matrix && matrix[date._id] && matrix[date._id][venue._id] && matrix[date._id][venue._id].length === 0" class="empty-cell" @click="handleQuickAdd(date._id, venue._id)">
                  <el-button type="primary" size="small" plain>添加</el-button>
                </div>
                <div v-else-if="matrix && matrix[date._id] && matrix[date._id][venue._id]" class="cell-content">
                  <div 
                    v-for="item in matrix[date._id][venue._id]" 
                    :key="item._id" 
                    class="schedule-item" 
                    :class="{ 'is-disabled': item.status === 0 }"
                  >
                    <div @click="handleViewSchedule(item)">
                      <div class="schedule-title">{{ item.title }}</div>
                      <div class="schedule-time">{{ formatTimeRange(item.startTime, item.endTime) }}</div>
                      <div v-if="item.agendaCount > 0" class="schedule-agenda-count">
                        <el-tag size="mini" type="info">{{ item.agendaCount }}个议程</el-tag>
                      </div>
                    </div>
                    <div class="schedule-item-actions">
                      <el-button 
                        type="danger" 
                        icon="el-icon-delete" 
                        size="mini" 
                        circle
                        @click.stop="handleDeleteSchedule(item)"
                      ></el-button>
                    </div>
                  </div>
                  <div class="add-schedule-btn" @click="handleQuickAdd(date._id, venue._id)">
                    <el-button type="primary" size="small" plain>添加</el-button>
                  </div>
                </div>
                <div v-else class="empty-cell" @click="handleQuickAdd(date._id, venue._id)">
                  <el-button type="primary" size="small" plain>添加</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 添加编辑日程对话框 -->
    <el-dialog
      :title="scheduleForm._id ? '编辑日程' : '添加日程'"
      :visible.sync="scheduleDialogVisible"
      width="800px"
      @close="resetScheduleForm"
    >
      <el-form
        ref="scheduleForm"
        :model="scheduleForm"
        :rules="scheduleRules"
        label-width="100px"
        v-loading="scheduleFormLoading"
      >
        <!-- 基本信息卡片 -->
        <el-card shadow="never" class="mb-4">
          <div slot="header" class="card-header">
            <span>基本信息</span>
          </div>
          <el-form-item label="标题" prop="title">
            <el-input v-model="scheduleForm.title" placeholder="请输入日程标题" />
          </el-form-item>
          <el-form-item label="主题" prop="theme">
            <el-input v-model="scheduleForm.theme" placeholder="请输入主题"></el-input>
          </el-form-item>
          <el-form-item label="日期" prop="dateId">
            <el-select v-model="scheduleForm.dateId" filterable placeholder="请选择日期" style="width: 100%">
              <el-option
                v-for="item in dateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="会场" prop="venueId">
            <el-select v-model="scheduleForm.venueId" filterable placeholder="请选择会场" style="width: 100%">
              <el-option
                v-for="item in venueOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围" prop="timeRange">
            <div style="display: flex; align-items: center; gap: 8px;">
              <el-input
                v-model="startTimeInput"
                placeholder="HH:mm"
                maxlength="5"
                style="width: 120px;"
                @input="handleStartTimeInput"
                @blur="handleTimeBlur"
              />
              <span>至</span>
              <el-input
                v-model="endTimeInput"
                placeholder="HH:mm"
                maxlength="5"
                style="width: 120px;"
                @input="handleEndTimeInput"
                @blur="handleTimeBlur"
              />
            </div>
          </el-form-item>
          <!-- <el-form-item label="排序" prop="sortOrder">
            <el-input
              v-model.number="scheduleForm.sortOrder"
              type="number"
              placeholder="数字越小排序越靠前"
              style="width: 200px"
            />
          </el-form-item> -->
        </el-card>
        
        <!-- 嘉宾信息卡片 -->
        <el-card shadow="never" class="mb-4">
          <div slot="header" class="card-header">
            <span>嘉宾信息</span>
            <el-button 
              type="text" 
              icon="el-icon-plus" 
              @click="showGuestSelector"
            >
              添加嘉宾
            </el-button>
          </div>
          
          <div v-if="scheduleForm.guests && scheduleForm.guests.length === 0" class="empty-block">
            <el-empty description="暂无嘉宾，请点击添加" :image-size="80"></el-empty>
          </div>
          
          <el-table
            v-else
            :data="scheduleForm.guests"
            style="width: 100%"
          >
            <el-table-column type="selection" width="60" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            
            <el-table-column label="头像" width="80" align="center">
              <template slot-scope="scope">
                <el-avatar 
                  :size="40" 
                  :src="scope.row.guestInfo?.avatar || ''" 
                  icon="el-icon-user"
                ></el-avatar>
              </template>
            </el-table-column>
            
            <el-table-column prop="guestInfo.name" label="姓名" />
            
            <el-table-column label="角色" width="180">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.role" 
                  placeholder="请输入嘉宾角色"
                  size="small"
                />
              </template>
            </el-table-column>
            
            <el-table-column label="排序" width="100">
              <template slot-scope="scope">
                <el-input-number 
                  v-model="scope.row.sortOrder" 
                  :min="0" 
                  :max="100"
                  size="small"
                  controls-position="right"
                />
              </template>
            </el-table-column>
            
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-button 
                  type="danger" 
                  icon="el-icon-delete" 
                  size="mini" 
                  circle
                  @click="removeGuest(scope.$index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        
        <!-- 展示配置卡片 -->
        <el-card shadow="never" class="mb-4">
          <div slot="header" class="card-header">
            <span>展示配置</span>
          </div>
          
          <el-form-item label="Banner图片">
            <FaImageUpload v-model="scheduleForm.bannerImage" :maxCount="1" />
            <div class="upload-tip">建议尺寸：1200 x 400 像素，JPG/PNG格式</div>
          </el-form-item>
          
          <el-form-item label="跳转按钮">
            <div class="button-config">
              <el-input 
                v-model="scheduleForm.buttonText" 
                placeholder="按钮文本（例如：立即报名）" 
                style="width: 200px; margin-right: 10px"
              />
              <el-input 
                v-model="scheduleForm.buttonLink" 
                placeholder="跳转链接URL（以https://开头）" 
                style="flex: 1"
              />
            </div>
          </el-form-item>
          
          <el-form-item label="简介内容">
            <div class="editor-container">
              <mc-rich-text
                v-model="scheduleForm.richTextIntro"
                :height="300"
                placeholder="请输入日程简介内容"
              />
            </div>
          </el-form-item>
        </el-card>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scheduleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitScheduleForm" :loading="submitLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 日期对话框 -->
    <el-dialog
      :title="addDateForm._id ? '编辑日期' : '添加日期'"
      :visible.sync="addDateDialogVisible"
      width="500px"
    >
      <el-form
        ref="addDateForm"
        :model="addDateForm"
        :rules="addDateRules"
        label-width="80px"
      >
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="addDateForm.date"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <!-- 名称和描述字段已移除，因为后端不支持这些字段 -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAddDate" :loading="addDateLoading">
          {{ addDateForm._id ? '保存更改' : '确定添加' }}
        </el-button>
      </span>
    </el-dialog>
    
    <!-- 快速添加会场对话框 -->
    <el-dialog
      :title="addVenueForm._id ? '编辑会场' : '添加会场'"
      :visible.sync="addVenueDialogVisible"
      width="500px"
    >
      <el-form
        ref="addVenueForm"
        :model="addVenueForm"
        :rules="addVenueRules"
        label-width="80px"
      >
        <el-form-item label="会场名称" prop="name">
          <el-input v-model="addVenueForm.name" placeholder="请输入会场名称" />
        </el-form-item>
        <el-form-item label="会场引导图" prop="image">
          <div class="image-upload-container">
            <FaImageUpload v-model="addVenueForm.image" :maxCount="1" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVenueDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAddVenue" :loading="addVenueLoading">确 定</el-button>
      </span>
    </el-dialog>
    
    <!-- 快速添加分类对话框 -->
    <el-dialog
      title="添加分类"
      :visible.sync="addCategoryDialogVisible"
      width="500px"
    >
      <el-form
        ref="addCategoryForm"
        :model="addCategoryForm"
        :rules="addCategoryRules"
        label-width="80px"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="addCategoryForm.name" placeholder="请输入分类名称" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCategoryDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAddCategory" :loading="addCategoryLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 嘉宾选择对话框 -->
    <el-dialog
      title="选择嘉宾"
      :visible.sync="guestDialogVisible"
      width="700px"
      append-to-body
    >
      <div class="guest-filter mb-2 flex items-center">
        <el-input
          v-model="guestKeyword"
          placeholder="搜索嘉宾姓名/职位/单位"
          prefix-icon="el-icon-search"
          clearable
          style="width: 240px; margin-right: 10px;"
          @keyup.enter.native="handleGuestSearch" 
          @clear="handleGuestSearch"
        />
        <el-select
          v-model="guestCategoryFilter"
          placeholder="按分组筛选"
          clearable
          style="width: 160px; margin-right: 10px;"
          @change="handleGuestCategoryChange"
        >
          <el-option v-for="c in guestCategoryOptions" :key="c._id" :label="c.name" :value="c._id"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleGuestSearch">搜索</el-button>
      </div>
      
      <el-table
        v-loading="guestLoading"
        :data="guestList" 
        height="400"
        @selection-change="handleGuestSelectionChange"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column label="头像" width="80" align="center">
          <template slot-scope="scope">
            <el-avatar 
              :size="40" 
              :src="scope.row.avatar || ''" 
              icon="el-icon-user"
            ></el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" />
        <el-table-column prop="position" label="职称" />
        <el-table-column prop="company" label="单位" />
        <el-table-column label="分组" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.categoryName" size="small" type="info">{{ scope.row.categoryName }}</el-tag>
            <span v-else class="text-gray-400">未分组</span>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 添加分页组件 -->
      <div class="pagination-container mt-4">
        <el-pagination
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" 
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" 
          :total="total"
        >
        </el-pagination>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="guestDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmGuestSelection">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 日程详情浮层 -->
    <el-dialog
      :visible.sync="scheduleDetailVisible"
      width="550px"
      :title="currentSchedule?.title || '日程详情'"
      :show-close="true"
      class="schedule-detail-dialog"
    >
      <div v-if="currentSchedule" class="schedule-detail-content">
        <!-- 副标题 -->
        <div class="subtitle mb-4">
          <span class="text-gray-600">{{ currentSchedule.theme || '议题名称示例' }}</span>
        </div>
        
        <!-- 时间信息 -->
        <div class="info-item flex items-center mb-3">
          <span class="info-label text-gray-500 min-w-20">时间</span>
          <span class="info-value">{{ formatTimeRange(currentSchedule.startTime, currentSchedule.endTime) }}</span>
        </div>
        
        <!-- 分类信息 -->
        <!-- <div class="info-item flex items-center mb-3">
          <span class="info-label text-gray-500 min-w-20">分类</span>
          <span class="info-value">
            <el-tag size="small" type="primary">{{ currentSchedule.category || 'test' }}</el-tag>
          </span>
        </div> -->
        
        <!-- 议程信息 -->
        <div class="info-item flex items-center mb-3">
          <span class="info-label text-gray-500 min-w-20">议程</span>
          <div class="info-value">
            <span class="mr-2">{{ currentSchedule.agendaCount || 0 }}个</span>
            <el-button type="text" size="small" @click="goToAgendaPage(currentSchedule)">
              查看议程
            </el-button>
          </div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleViewScheduleDetail(currentSchedule)">详情</el-button>
        <el-button size="small" type="primary" @click="handleEditSchedule(currentSchedule)">编辑</el-button>
        <el-button size="small" type="danger" @click="handleDeleteSchedule(currentSchedule)">删除</el-button>
      </div>
    </el-dialog>
    
    <!-- 发送邮件弹窗 -->
    <el-dialog
      title="发送邮件给嘉宾"
      :visible.sync="emailDialogVisible"
      width="90%"
      :fullscreen="false"
      :close-on-click-modal="true"
      :destroy-on-close="false"
      custom-class="email-dialog"
      @closed="handleEmailDialogClosed"
    >
      <div class="email-container">
        <!-- 邮件配置区域 -->
        <div class="email-config-section">
          <el-card shadow="never" class="mb-4">
            <div slot="header" class="card-header flex justify-between items-center">
              <span>邮件管理</span>
              <div>
                <el-button type="primary" size="small" @click="saveEmailConfig" v-if="emailActiveTab === 'config'">保存配置</el-button>
                <el-button type="success" size="small" @click="previewEmail" v-if="emailActiveTab === 'config'">预览效果</el-button>
                <el-button type="info" size="small" @click="refreshEmailTaskList" v-if="emailActiveTab === 'status'">刷新状态</el-button>
              </div>
            </div>
            
            <!-- Tab 切换区域 -->
            <el-tabs v-model="emailActiveTab" @tab-click="handleEmailTabClick">
              <!-- 邮件配置Tab -->
              <el-tab-pane label="邮件配置" name="config">
                <el-form :model="emailConfig" label-width="100px" size="small">
                  <el-form-item label="邮件主题">
                    <el-input v-model="emailConfig.subject" placeholder="请输入邮件主题"></el-input>
                  </el-form-item>
                  <el-form-item label="邮件内容">
                    <el-input
                      type="textarea"
                      :rows="10"
                      v-model="emailConfig.content"
                      placeholder="请输入邮件内容，支持以下变量：${name}、${title}、${time}、${address}等"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="useDefaultEmailTemplate">使用默认模板</el-button>
                    <el-button type="info" @click="previewEmail">预览效果</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              
              <!-- 发送状态Tab -->
              <el-tab-pane label="发送状态" name="status">
                <el-table :data="emailTaskList" style="width: 100%" v-loading="emailTaskLoading">
                  <el-table-column prop="guest.name" label="嘉宾姓名" width="120"></el-table-column>
                  <el-table-column prop="guest.email" label="邮箱地址" width="200"></el-table-column>
                  <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="scope">
                      <el-tag :type="getEmailStatusType(scope.row.status)">{{getEmailStatusText(scope.row.status)}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sentAt" label="发送时间" width="180">
                    <template slot-scope="scope">
                      {{scope.row.sentAt ? formatDate(scope.row.sentAt) : '-'}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="errorMessage" label="错误信息"></el-table-column>
                  <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="text"
                        @click="resendEmail(scope.row)"
                        :disabled="scope.row.status === 'sending'"
                      >重新发送</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </div>

        <!-- 嘉宾选择区域 -->
        <div class="guest-select-section">
          <el-card shadow="never">
            <div slot="header" class="card-header">
              <span>选择收件人</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="selectAllGuests">全选</el-button>
            </div>
            
            <el-table
              ref="guestTable"
              :data="guestList"
              style="width: 100%"
              @selection-change="handleGuestSelectionChange"
              v-loading="guestLoading"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="name" label="姓名" width="120"></el-table-column>
              <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
              <el-table-column prop="position" label="职位"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="text"
                    @click="sendSingleEmail(scope.row)"
                    :disabled="!scope.row.email"
                  >发送邮件</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <div class="dialog-footer" style="margin-top: 20px; text-align: right;">
              <el-button @click="emailDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="sendEmail" :loading="sendingEmail">发送邮件</el-button>
            </div>
          </el-card>
        </div>
      </div>
    </el-dialog>

    <!-- 发送短信弹窗 -->
    <el-dialog
      title="发送短信给嘉宾"
      :visible.sync="smsDialogVisible"
      width="90%"
      :fullscreen="false"
      :close-on-click-modal="true"
      :destroy-on-close="false"
      custom-class="sms-dialog"
      @closed="handleSmsDialogClosed"
    >
      <div class="sms-container">
        <!-- 短信配置区域 -->
        <div class="sms-config-section">
          <el-card shadow="never" class="mb-4">
            <div slot="header" class="card-header flex justify-between items-center">
              <span>短信管理</span>
              <div>
                <el-button type="primary" size="small" @click="saveSmsConfig" v-if="activeTab === 'config'">保存配置</el-button>
                <el-button type="success" size="small" @click="previewSms" v-if="activeTab === 'config'">链接网站预览效果</el-button>
                <el-button type="info" size="small" @click="refreshTaskList" v-if="activeTab === 'status'">刷新状态</el-button>
              </div>
            </div>
            
            <!-- Tab 切换区域 -->
            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
              <!-- 短信配置Tab -->
              <el-tab-pane label="短信配置" name="config">
            <el-form :model="smsConfig" label-width="100px" size="small">
              <el-form-item label="顶部Banner">
                <el-upload
                  class="banner-uploader"
                  action="/api/upload"
                  :show-file-list="false"
                  :on-success="(res) => handleBannerSuccess(res, 'topBanner')"
                  :before-upload="beforeBannerUpload"
                >
                  <img v-if="smsConfig.topBanner" :src="smsConfig.topBanner" class="banner-image">
                  <i v-else class="el-icon-plus banner-uploader-icon"></i>
                </el-upload>
                <div class="upload-tip">建议尺寸: 750px × 200px</div>
              </el-form-item>
              
              <el-form-item label="短信内容">
                <div class="sms-config-fields">
                  <!-- 会议配置区域 -->
                  <el-form-item label="会议标题" class="mb-3">
                    <el-input 
                      v-model="smsConfig.conferenceTitle" 
                      placeholder="请输入会议标题"
                      maxlength="20"
                      @input="filterSpecialChars('conferenceTitle')"
                    ></el-input>
                  </el-form-item>
                  
                  <el-form-item label="日期范围" class="mb-3">
                    <el-input 
                      v-model="smsConfig.dateRangeText" 
                      placeholder="2025年5月1~4日"
                      maxlength="20"
                      @input="filterSpecialChars('dateRangeText')"
                    ></el-input>
                  </el-form-item>
                  
                  <el-form-item label="城市" class="mb-3">
                    <el-input 
                      v-model="smsConfig.city" 
                      placeholder="请输入城市名称"
                      maxlength="20"
                      @input="filterSpecialChars('city')"
                    ></el-input>
                  </el-form-item>
                  
                  <el-form-item label="详情地址" class="mb-3">
                    <el-input 
                      v-model="smsConfig.addressDetails" 
                      placeholder="请输入详细地址"
                      maxlength="20"
                      @input="filterSpecialChars('addressDetails')"
                    ></el-input>
                  </el-form-item>
                  
                  <el-form-item label="任务联系人" class="mb-3">
                    <el-input 
                      v-model="smsConfig.taskContact" 
                      placeholder="请输入任务负责人姓名"
                      maxlength="20"
                      @input="filterSpecialChars('taskContact')"
                    ></el-input>
                  </el-form-item>
                  
                  <el-form-item label="联系电话" class="mb-3">
                    <el-input 
                      v-model="smsConfig.taskContactPhone" 
                      placeholder="请输入联系电话"
                      maxlength="20"
                      @input="filterSpecialChars('taskContactPhone')"
                    ></el-input>
                  </el-form-item>
                  
                  <!-- <el-form-item label="会务联系人" class="mb-3">
                    <el-input 
                      v-model="smsConfig.eventContact" 
                      placeholder="小王"
                      maxlength="20"
                      @input="filterSpecialChars('eventContact')"
                    ></el-input>
                  </el-form-item>
                  
                  <el-form-item label="联系人电话" class="mb-3">
                    <el-input 
                      v-model="smsConfig.eventContactPhone" 
                      placeholder="18000000000"
                      maxlength="20"
                      @input="filterSpecialChars('eventContactPhone')"
                    ></el-input>
                  </el-form-item> -->
                </div>
              </el-form-item>
              
              <el-form-item label="底部Banner">
                <el-upload
                  class="banner-uploader"
                  action="/api/upload"
                  :show-file-list="false"
                  :on-success="(res) => handleBannerSuccess(res, 'bottomBanner')"
                  :before-upload="beforeBannerUpload"
                >
                  <img v-if="smsConfig.bottomBanner" :src="smsConfig.bottomBanner" class="banner-image">
                  <i v-else class="el-icon-plus banner-uploader-icon"></i>
                </el-upload>
                <div class="upload-tip">建议尺寸: 750px × 200px</div>
              </el-form-item>
            </el-form>
              </el-tab-pane>
              
              <!-- 发送状态Tab -->
              <el-tab-pane label="发送状态" name="status">
                <sms-task-list
                  ref="smsTaskList"
                  :archive-id="archiveId"
                  @view-details="viewTaskDetails"
                  @cancel-task="cancelTask"
                />
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </div>
        
        <!-- 嘉宾列表区域 -->
        <div class="guest-list-section">
          <el-card shadow="never">
            <div slot="header" class="card-header flex justify-between items-center">
              <div class="flex items-center">
                <span class="mr-4">嘉宾列表</span>
                <el-input
                  placeholder="搜索嘉宾姓名/职位/单位"
                  v-model="guestSearchKeyword"
                  class="w-64"
                  prefix-icon="el-icon-search"
                  clearable
                  @clear="loadGuests"
                  @keyup.enter.native="loadGuests"
                ></el-input>
                <el-button type="primary" size="small" class="ml-2" @click="loadGuests">搜索</el-button>
                <el-button type="primary" size="small" class="ml-2" @click="generateAllSmsList">生成短信列表</el-button>
              </div>
              <el-button 
                type="success" 
                size="small" 
                :disabled="selectedGuests.length === 0"
                @click="sendSms"
              >
                发送短信 ({{ selectedGuests.length }})
              </el-button>
            </div>
            
            <!-- 嘉宾表格 -->
            <el-table
              ref="guestTable"
              v-loading="guestLoading"
              :data="guestList"
              height="450"
              border
              @selection-change="handleGuestSelectionChange"
            >
              <el-table-column type="selection" width="40"></el-table-column>
              
              <el-table-column label="嘉宾信息" min-width="150">
                <template slot-scope="scope">
                  <div class="flex items-start">
                    <el-avatar 
                      :size="40" 
                      :src="scope.row.avatar || ''" 
                      icon="el-icon-user"
                      class="mr-3"
                    ></el-avatar>
                    <div>
                      <div class="font-medium">{{ scope.row.name }}</div>
                      <div class="text-gray-500 text-xs mt-1">{{ scope.row.phone || '无手机号' }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column prop="position" label="职位" min-width="100"></el-table-column>
              <el-table-column prop="company" label="单位" min-width="120"></el-table-column>
              
              <el-table-column label="日程安排" min-width="200">
                <template slot-scope="scope">
                  <div v-if="scope.row.schedules && scope.row.schedules.length > 0">
                    <div 
                      v-for="(schedule, index) in scope.row.schedules" 
                      :key="index"
                      class="guest-schedule-item"
                    >
                      <div class="schedule-title">{{ schedule.title }}</div>
                      <div class="schedule-info">
                        <span class="venue">{{ getVenueName(schedule.venueId) }}</span>
                        <span class="time">{{ formatDate(schedule.dateId) }} {{ schedule.startTime }}-{{ schedule.endTime }}</span>
                        <el-tag size="mini" type="info">{{ schedule.role || '嘉宾' }}</el-tag>
                      </div>
                    </div>
                  </div>
                  <div v-else class="empty-text">无日程安排</div>
                </template>
              </el-table-column>
              
              <el-table-column label="短信操作" width="150">
                <template slot-scope="scope">
                  <div class="sms-actions">
                    <el-button 
                      type="primary" 
                      size="mini" 
                      @click="previewGuestSms(scope.row)"
                    >
                      查看
                    </el-button>
                    <el-button 
                      type="success" 
                      size="mini" 
                      @click="sendSingleSms(scope.row)"
                      :disabled="!scope.row.phone"
                    >
                      发送
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            
            <!-- 添加分页组件 -->
            <div class="pagination-container mt-4">
              <el-pagination
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]" 
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" 
                :total="total"
              >
              </el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </el-dialog>
    
    <!-- 短信预览弹窗 -->
    <el-dialog
      title="链接网站预览"
      :visible.sync="previewDialogVisible"
      width="400px"
      :fullscreen="false"
      :close-on-click-modal="true"
      :destroy-on-close="false"
    >
      <div class="sms-preview-container">
        <iframe v-if="previewUrl" :src="previewUrl" class="sms-preview-frame"></iframe>
        <div v-else class="sms-preview-placeholder">暂无预览内容</div>
      </div>
    </el-dialog>
    
    <!-- 嘉宾短信预览弹窗 -->
    <el-dialog
      title="嘉宾短信预览"
      :visible.sync="smsPreviewDialogVisible"
      width="500px"
      :fullscreen="false"
      :close-on-click-modal="true"
      :destroy-on-close="false"
    >
      <div v-if="currentPreviewSms" class="guest-sms-preview">
        <!-- 短信内容 -->
        <div class="sms-content-preview">
          <div class="preview-label">短信内容预览：</div>
          <div class="preview-content">
            <div class="content-text">
              {{ currentPreviewSms.content }}
            </div>
            <div v-if="smsConfig.contactInfo" class="contact-info-preview">
              {{ smsConfig.contactInfo }}
            </div>
          </div>
        </div>
      </div>
      
      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="smsPreviewDialogVisible = false">关闭</el-button>
        <el-button 
          type="primary" 
          @click="sendSingleSms(currentPreviewSms.guest)" 
          :disabled="!currentPreviewSms || !currentPreviewSms.guest.phone"
        >
          发送短信
        </el-button>
      </div>
    </el-dialog>
    
    <!-- 批量短信列表弹窗 -->
    <el-dialog
      title="嘉宾短信列表"
      :visible.sync="smsListDialogVisible"
      width="80%"
      :fullscreen="false"
      :close-on-click-modal="true"
      :destroy-on-close="false"
      top="5vh"
    >
      <div class="sms-list-container">
        <div class="sms-list-header mb-4">
          <div class="flex items-center justify-between">
            <div class="sms-list-title">已为 {{ smsListData.length }} 位嘉宾生成短信内容&nbsp;</div>
            <div class="sms-list-actions">
              <el-button type="success" size="small" @click="sendAllSms" :disabled="smsListData.length === 0">
                发送全部短信
              </el-button>
            </div>
          </div>
        </div>
        
        <el-table
          v-loading="smsListLoading"
          :data="smsListData"
          border
          max-height="600px"
        >
          <el-table-column type="index" width="50" label="#"></el-table-column>
          
          <el-table-column label="嘉宾信息" min-width="150">
            <template slot-scope="scope">
              <div class="flex items-start">
                <el-avatar 
                  :size="40" 
                  :src="scope.row.guest.avatar || ''" 
                  icon="el-icon-user"
                  class="mr-3"
                ></el-avatar>
                <div>
                  <div class="font-medium">{{ scope.row.guest.name }}</div>
                  <div class="text-gray-500 text-xs mt-1">{{ scope.row.guest.phone || '无手机号' }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="短信内容" min-width="300">
            <template slot-scope="scope">
              <div class="sms-content-card">
                <div class="content-text text-sm">{{ scope.row.content }}</div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="发送状态" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'success' ? 'success' : (scope.row.status === 'failed' ? 'danger' : 'info')">
                {{ 
                  scope.row.status === 'success' ? '发送成功' : 
                  (scope.row.status === 'failed' ? '发送失败' : 
                  (scope.row.status === 'sending' ? '发送中' : '待发送')) 
                }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <div class="sms-item-actions">
                <el-button 
                  type="primary" 
                  size="mini" 
                  icon="el-icon-view" 
                  @click="previewSmsListItem(scope.row)"
                >
                  预览
                </el-button>
                <el-button 
                  type="success" 
                  size="mini" 
                  icon="el-icon-message" 
                  @click="sendSmsListItem(scope.row)"
                  :disabled="!scope.row.guest.phone || scope.row.status === 'sending' || scope.row.status === 'success'"
                >
                  发送
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    
    <!-- 短信任务列表 -->
    <el-card v-if="activeTab === 'status'" class="mb-4">
      <div slot="header">
        <span>短信任务列表</span>
      </div>
      <sms-task-list
        ref="smsTaskList"
        :archive-id="archiveId"
        @view-details="handleViewTaskDetails"
        @cancel-task="handleCancelTask"
      />
    </el-card>

    <!-- 导入对话框 -->
    <el-dialog
      title="导入日程"
      :visible.sync="importDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-steps :active="importStep" finish-status="success" simple style="margin-bottom: 20px">
        <el-step title="上传文件"></el-step>
        <el-step title="数据预览"></el-step>
        <el-step title="导入结果"></el-step>
      </el-steps>

      <!-- 步骤1：上传文件 -->
      <div v-if="importStep === 0">
        <div class="import-tips">
          <p><strong>导入说明：</strong></p>
          <p>1. 请先下载导入模板，按照模板格式填写数据</p>
          <p>2. 支持同时导入日程表和议程表两个工作表</p>
          <p>3. 日程表字段：日期、会场名称、开始时间、结束时间、日程标题、日程主题、嘉宾姓名、嘉宾分组、嘉宾角色</p>
          <p>4. 议程表字段：所属日程标题、议程标题、副标题、开始时间、结束时间、嘉宾姓名、嘉宾分组、嘉宾角色、描述、跳转按钮、跳转链接</p>
          <p>5. 时间格式：HH:MM（如：09:00）</p>
          <p>6. 日期格式：YYYY-MM-DD（如：2024-12-01）</p>
          <p>7. 多个嘉宾请用"、"分隔（如：张三、李四）</p>
          <p>8. 嘉宾分组与嘉宾姓名按顺序一一对应，用于区分同名嘉宾（如：专家组、主办方）</p>
          <p>9. 分组留空时按姓名匹配；匹配不到的嘉宾和分组会自动创建，导入前可在下一步复核</p>
          <el-button type="text" @click="downloadTemplate">下载导入模板</el-button>
        </div>
        
        <el-form label-width="100px" class="import-form">
          <el-form-item label="Excel文件">
            <el-upload
              class="excel-uploader"
              action="#"
              :auto-upload="false"
              :on-change="handleExcelChange"
              :file-list="excelFileList"
              accept=".xlsx,.xls"
            >
              <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传 xlsx/xls 文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <!-- 步骤2：数据预览 -->
      <div v-if="importStep === 1">
        <div class="preview-stats">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-label">日程总数</div>
                <div class="stat-value">{{ previewData.schedules.total }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-item success">
                <div class="stat-label">日程有效</div>
                <div class="stat-value">{{ previewData.schedules.valid }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-item">
                <div class="stat-label">议程总数</div>
                <div class="stat-value">{{ previewData.agendas.total }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-item success">
                <div class="stat-label">议程有效</div>
                <div class="stat-value">{{ previewData.agendas.valid }}</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 嘉宾匹配复核：导入前告知将自动新建哪些嘉宾/分组 -->
        <div v-if="hasGuestResolution" class="guest-resolution">
          <el-alert
            v-if="previewData.guestResolution.createdGuests.length || previewData.guestResolution.createdCategories.length"
            type="warning"
            :closable="false"
            show-icon
            style="margin-bottom: 10px"
          >
            <span>
              导入时将自动新建
              <strong>{{ previewData.guestResolution.createdGuests.length }}</strong> 位嘉宾、
              <strong>{{ previewData.guestResolution.createdCategories.length }}</strong> 个分组，请确认无误后再导入
            </span>
          </el-alert>

          <el-alert
            v-if="previewData.guestResolution.ambiguous.length"
            type="info"
            :closable="false"
            show-icon
            style="margin-bottom: 10px"
          >
            <span>
              有 <strong>{{ previewData.guestResolution.ambiguous.length }}</strong>
              项匹配到多个同名嘉宾，已按最新创建的一条处理
            </span>
          </el-alert>

          <el-table :data="guestResolutionRows" size="small" style="width: 100%" max-height="240">
            <el-table-column prop="type" label="类型" width="90"></el-table-column>
            <el-table-column prop="name" label="名称" width="120"></el-table-column>
            <el-table-column prop="category" label="分组" width="120">
              <template v-slot="scope">{{ scope.row.category || '（无分组）' }}</template>
            </el-table-column>
            <el-table-column prop="rows" label="所在行"></el-table-column>
          </el-table>
        </div>

        <div v-if="previewData.errors.length" class="error-list">
          <h4>错误详情：</h4>
          <el-table :data="previewData.errors" size="small" style="width: 100%" max-height="300">
            <el-table-column prop="sheet" label="工作表" width="80"></el-table-column>
            <el-table-column prop="row" label="行号" width="80"></el-table-column>
            <el-table-column label="错误信息">
              <template v-slot="scope">
                <div v-for="(error, index) in scope.row.errors" :key="index">
                  {{ error.field }}: {{ error.message }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 步骤3：导入结果 -->
      <div v-if="importStep === 2">
        <div class="import-result">
          <el-result
            :icon="importResult.success ? 'success' : 'error'"
            :title="importResult.success ? '导入成功' : '导入失败'"
            :subTitle="importResult.message"
          >
            <template v-if="importResult.success">
              <div class="result-stats">
                <p>日程成功导入：{{ importResult.data.schedules.success }} 条</p>
                <p>日程失败记录：{{ importResult.data.schedules.failed }} 条</p>
                <p>议程成功导入：{{ importResult.data.agendas.success }} 条</p>
                <p>议程失败记录：{{ importResult.data.agendas.failed }} 条</p>
                <template v-if="importResult.data.guestResolution">
                  <p v-if="importResult.data.guestResolution.createdGuests.length">
                    新建嘉宾：{{ importResult.data.guestResolution.createdGuests.length }} 位
                    （{{ importResult.data.guestResolution.createdGuests.map(g => g.name).join('、') }}）
                  </p>
                  <p v-if="importResult.data.guestResolution.createdCategories.length">
                    新建分组：{{ importResult.data.guestResolution.createdCategories.length }} 个
                    （{{ importResult.data.guestResolution.createdCategories.map(c => c.name).join('、') }}）
                  </p>
                </template>
              </div>
            </template>
          </el-result>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelImport">{{ importStep === 2 ? '关闭' : '取消' }}</el-button>
        <el-button 
          v-if="importStep < 2" 
          type="primary" 
          @click="nextStep"
          :loading="importing"
          :disabled="!canProceed"
        >{{ importStep === 1 ? '开始导入' : '下一步' }}</el-button>
      </div>
    </el-dialog>

    <!-- 主题设置弹窗 -->
    <el-dialog
      title="日程板块主题设置"
      :visible.sync="themeDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="handleThemeDialogClose"
    >
      <el-form ref="themeForm" :model="themeForm" label-width="100px">
        <el-form-item label="主题样式">
          <el-radio-group v-model="themeForm.theme" @change="handleThemeChange">
            <el-radio label="default">
              <div class="theme-preview">
                <div class="theme-name">默认主题</div>
                <div class="theme-desc">简洁大方的默认样式</div>
              </div>
            </el-radio>
            <el-radio label="modern">
              <div class="theme-preview">
                <div class="theme-name">现代主题</div>
                <div class="theme-desc">简洁现代的视觉风格</div>
              </div>
            </el-radio>
            <el-radio label="elegant">
              <div class="theme-preview">
                <div class="theme-name">优雅主题</div>
                <div class="theme-desc">优雅精致的视觉风格</div>
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="主题预览">
          <div class="theme-preview-box" :class="'theme-' + themeForm.theme">
            <div class="preview-header">日程矩阵视图</div>
            <div class="preview-content">
              <div class="preview-schedule">
                <div class="schedule-title">示例日程</div>
                <div class="schedule-time">09:00-10:00</div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="themeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveThemeSettings" :loading="themeSaving">保存设置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getScheduleMatrix, getScheduleList, addSchedule, updateSchedule, deleteSchedule, checkTimeConflict } from '@/api/schedule/schedule'
import { getArchiveList, updateArchiveTheme } from '@/api/schedule/archive'
import { getVenueList, addVenue, editVenue, deleteVenue } from '@/api/schedule/venue'
import { getDateList, addDate, editDate, deleteDate } from '@/api/schedule/date'
import { formatDate, formatDateByType } from '@/utils/date'
import { mapGetters } from 'vuex'
import { 
  getArchiveOptions,
  getDateOptions,
  getVenueOptions,
  getCategoryOptions,
  addScheduleDate,
  addScheduleVenue,
  addCategory
} from '@/api/schedule'
import { getGuestList, getGuestListWithSchedules, getGuestCategories } from '@/api/guest'
import McRichText from '@/custom-schema-template/components/McRichText'
import axios from 'axios'
// 导入FaImageUpload组件
import FaImageUpload from 'faim/dist/components/ImageUpload/index.vue'
import SmsTaskList from './components/SmsTaskList.vue'

// 配置axios baseURL
const apiBaseUrl = process.env.VUE_APP_BASE_API || '';
axios.defaults.baseURL = apiBaseUrl;

export default {
  name: 'ScheduleManagement',
  components: {
    McRichText,
    FaImageUpload,
    SmsTaskList
  },
  data() {
    return {
      // 时间输入相关
      startTimeInput: '',
      endTimeInput: '',
      // 邮件相关
      emailDialogVisible: false,
      emailActiveTab: 'config',
      emailConfig: {
        subject: '',
        content: '',
        archiveId: '',
        conferenceTitle: '',
        dateRangeText: '',
        city: '',
        addressDetails: '',
        taskContact: '',
        taskContactPhone: ''
      },
      emailTaskList: [],
      emailTaskLoading: false,
      sendingEmail: false,
      // 列表数据
      loading: false,
      matrixData: {
        dates: [],
        venues: []
      },
      
      // 日程详情浮层
      scheduleDetailVisible: false,
      currentSchedule: null,
      
      // 归档信息
      archiveId: '',
      archiveName: '',
      
      // 筛选条件
      keywordSearch: '',
      dateRange: null,
      selectedDateId: '',
      selectedVenueId: '', 
      selectedCategory: '',
      
      // 分类选项
      categoryOptions: [
        { label: 'test', value: 'test' }
      ],
      
      // 流程状态
      hasVenues: false,
      hasDates: false,
      
      // 日程表单相关
      scheduleDialogVisible: false,
      scheduleFormLoading: false,
      submitLoading: false,
      scheduleForm: {
        _id: '',
        title: '',
        theme: '',
        dateId: '',
        venueId: '',
        archiveId: '',
        timeRange: null,
        manager: '',
        contact: '',
        expectedAttendees: 0,
        status: '1', // 默认已确认
        description: '',
        // 新增字段
        sortOrder: 0,
        bannerImage: '',
        buttonText: '',
        buttonLink: '',
        richTextIntro: '',
        guests: []
      },
      scheduleRules: {
        title: [{ required: true, message: '请输入日程标题', trigger: 'blur' }],
        dateId: [{ required: true, message: '请选择日期', trigger: 'change' }],
        venueId: [{ required: true, message: '请选择会场', trigger: 'change' }],
        timeRange: [{ required: true, message: '请选择时间范围', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      dateOptions: [],
      venueOptions: [],
      
      // 快速添加日期相关
      addDateDialogVisible: false,
      addDateLoading: false,
      addDateForm: {
        archiveId: '',
        _id: '',
        date: null
      },
      addDateRules: {
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }]
      },
      
      // 快速添加会场相关
      addVenueDialogVisible: false,
      addVenueLoading: false,
      addVenueForm: {
        archiveId: '',
        _id: '',
        name: '',
        image: ''
      },
      addVenueRules: {
        name: [{ required: true, message: '请输入会场名称', trigger: 'blur' }]
      },
      
      // 快速添加分类相关
      addCategoryDialogVisible: false,
      addCategoryLoading: false,
      addCategoryForm: {
        name: ''
      },
      addCategoryRules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      },
      
      // 分类选项
      categoryId: '',
      categoryOptions: [],
      
      // 添加嘉宾相关数据
      guestDialogVisible: false,
      guestLoading: false,
      guestList: [],
      guestKeyword: '',
      selectedGuests: [],
      guestCategoryOptions: [],
      guestCategoryMap: {},
      guestCategoryFilter: '',
      
      // 上传相关
      uploadHeaders: {
        // 可能需要的授权头
      },
      uploadUrl: '/api/schedule/import/excel',
      smsDialogVisible: false,
      smsConfig: {
        topBanner: '',
        bottomBanner: '',
        content: '',
        // API需要的字段
        conferenceTitle: '',
        dateRangeText: '',
        city: '',
        addressDetails: '',
        taskContact: '',
        taskContactPhone: '',
        eventContact: '',
        eventContactPhone: '',
        archiveId: ''
      },
      previewUrl: '',
      guestSearchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      previewDialogVisible: false,
      
      // 主题设置相关
      themeDialogVisible: false,
      themeSaving: false,
      themeForm: {
        theme: 'default' // 默认主题
      },
      smsVariables: {
        name: '',
        title: '',
        time: '',
        address: '',
        address_details: '',
        link: ''
      },
      showGeneratedContent: false,
      smsPreviewDialogVisible: false,
      currentPreviewSms: null,
      smsListDialogVisible: false,
      smsListLoading: false,
      smsListData: [],
      templatePreviewVisible: false,
      smsConfigContent: '',
      uploadRef: null,
      uploadProgress: 0,
      isUploading: false,
      activeTab: 'config',
      smsStatistics: {
        total: 0,
        pending: 0,
        processing: 0,
        completed: 0
      },
      smsTaskLoading: false,
      smsTaskList: [],
      currentTaskDetail: null,
      taskDetailDialogVisible: false,
      pollingTimer: null,
      importDialogVisible: false,
      importStep: 0,
      importing: false,
      canProceed: false,
      previewData: {
        schedules: { total: 0, valid: 0 },
        agendas: { total: 0, valid: 0 },
        errors: [],
        // 嘉宾匹配复核：将新建的嘉宾/分组、以及命中多条的歧义项
        guestResolution: { createdGuests: [], createdCategories: [], ambiguous: [] }
      },
      importResult: {
        success: false,
        message: '',
        data: {
          schedules: { success: 0, failed: 0 },
          agendas: { success: 0, failed: 0 },
          guestResolution: { createdGuests: [], createdCategories: [], ambiguous: [] }
        }
      },
      excelFileList: []
    }
  },
  computed: {
    ...mapGetters(['userInfo']),

    // 嘉宾匹配复核：是否有需要用户确认的内容
    hasGuestResolution() {
      const r = this.previewData && this.previewData.guestResolution;
      if (!r) return false;
      return !!(r.createdGuests.length || r.createdCategories.length || r.ambiguous.length);
    },

    // 把三类复核项拍平成一张表，便于统一展示
    guestResolutionRows() {
      const r = (this.previewData && this.previewData.guestResolution) || {};
      const toRow = (type) => (item) => ({
        type,
        name: item.name,
        category: item.category,
        rows: (item.rows || []).join('、')
      });

      return [
        ...(r.createdCategories || []).map(toRow('新建分组')),
        ...(r.createdGuests || []).map(toRow('新建嘉宾')),
        ...(r.ambiguous || []).map(item => ({
          type: '同名多条',
          name: item.name,
          category: item.category,
          rows: `${(item.rows || []).join('、')}（命中 ${item.matchedCount} 条，取最新）`
        }))
      ];
    },

    // 根据日期和会场获取日程项目
    scheduleItemsByDateAndVenue() {
      const map = {}
      
      if (this.matrixData && this.matrixData.items && Array.isArray(this.matrixData.items) && this.matrixData.items.length > 0) {
        try {
          this.matrixData.items.forEach(item => {
            if (!item) return;
            
            try {
              // 处理dateId和venueId可能是对象或字符串的情况
              const dateId = item.dateId ? (typeof item.dateId === 'object' ? item.dateId._id : item.dateId) : null;
              const venueId = item.venueId ? (typeof item.venueId === 'object' ? item.venueId._id : item.venueId) : null;
              
              if (!dateId || !venueId) return;
              
              const key = `${dateId}-${venueId}`
              if (!map[key]) {
                map[key] = []
              }
              
              // 将完整的item添加到映射中，确保含有所有原始数据
              map[key].push({
                ...item,
                // 添加额外字段供展示使用
                _origDateId: dateId,
                _origVenueId: venueId
              })
            } catch (itemError) {
              console.error('处理日程项目映射时出错:', itemError, item);
            }
          })
          
          // 按开始时间排序
          Object.keys(map).forEach(key => {
            if (!map[key]) return;
            
            try {
              map[key].sort((a, b) => {
                if (!a || !a.startTime || !b || !b.startTime) return 0;
                return new Date('2023/01/01 ' + a.startTime) - new Date('2023/01/01 ' + b.startTime)
              })
            } catch (sortError) {
              console.error('排序日程项目映射时出错:', sortError, map[key]);
            }
          })
        } catch (error) {
          console.error('构建日程项目映射时出错:', error);
        }
      }
      
      return map
    },
    
    // 生成矩阵数据结构
    matrix() {
      const matrix = {};
      
      // 初始化矩阵结构
      if (this.matrixData.dates && this.matrixData.venues) {
        // 首先为每个日期创建一个对象
        this.matrixData.dates.forEach(date => {
          const dateId = date._id;
          matrix[dateId] = {};
          
          // 为每个场馆创建一个数组
          this.matrixData.venues.forEach(venue => {
            const venueId = venue._id;
            matrix[dateId][venueId] = [];
          });
        });
        
        // 填充日程项目数据
        if (this.matrixData.items && this.matrixData.items.length > 0) {
          this.matrixData.items.forEach(item => {
            if (!item) return;
            
            // 处理dateId和venueId可能是对象、字符串或null的情况
            let dateId = null;
            let venueId = null;
            
            // 检查dateId是否存在且不为null
            if (item.dateId) {
              dateId = typeof item.dateId === 'object' ? item.dateId._id : item.dateId;
            }
            
            // 检查venueId是否存在且不为null
            if (item.venueId) {
              venueId = typeof item.venueId === 'object' ? item.venueId._id : item.venueId;
            }
            
            // 确保日期和场馆ID都有效且矩阵中存在对应的位置
            if (dateId && venueId && matrix[dateId] && matrix[dateId][venueId]) {
              matrix[dateId][venueId].push(item);
            }
          });
          
          // 对每个单元格中的项目按时间排序
          Object.keys(matrix).forEach(dateId => {
            Object.keys(matrix[dateId]).forEach(venueId => {
              if (matrix[dateId][venueId].length > 0) {
                matrix[dateId][venueId].sort((a, b) => {
                  return new Date('2023/01/01 ' + a.startTime) - new Date('2023/01/01 ' + b.startTime);
                });
              }
            });
          });
        }
      }
      
      return matrix;
    },
    
    // 添加嘉宾相关计算属性
    filteredGuestList() {
      // 如果guestList不存在，则返回空数组
      if (!this.guestList || !Array.isArray(this.guestList)) {
        return [];
      }
      
      // 如果没有搜索关键字，则返回原列表
      if (!this.guestKeyword) { // <--- 修改为 guestKeyword
        return this.guestList;
      }
      
      // 否则按名称、职位或单位过滤
      const keyword = this.guestKeyword.toLowerCase(); // <--- 修改为 guestKeyword
      return this.guestList.filter(guest => {
        return (
          (guest.name && guest.name.toLowerCase().includes(keyword)) ||
          (guest.position && guest.position.toLowerCase().includes(keyword)) ||
          (guest.company && guest.company.toLowerCase().includes(keyword))
        );
      });
    }
  },
  created() {
    // Get query parameters
    const { archiveId, archiveName } = this.$route.query;
    
    // Set archive ID and name if provided in URL
    if (archiveId) {
      this.archiveId = archiveId;
      console.log('从URL参数获取到归档ID:', archiveId);
    }
    
    if (archiveName) {
      this.archiveName = decodeURIComponent(archiveName);
      console.log('从URL参数获取到归档名称:', this.archiveName);
    }
    
    // Initialize data
    this.checkSetupStatus();
    this.getScheduleMatrix();
    this.getArchiveOptions();
    this.getCategoryOptions();
    
    // 加载短信配置
    this.loadSmsConfig();
  },
  beforeDestroy() {
    // 清理轮询定时器
    this.stopPolling();
  },
  methods: {
    // 邮件相关方法
    openEmailDialog() {
      this.emailDialogVisible = true;
      this.loadGuests();
      // 初始化邮件配置
      this.emailConfig = {
        subject: `${this.archiveName}邀请函`,
        content: '',
        archiveId: this.archiveId,
        conferenceTitle: this.archiveName,
        dateRangeText: this.dateRangeText,
        city: this.city,
        addressDetails: this.addressDetails,
        taskContact: this.taskContact,
        taskContactPhone: this.taskContactPhone
      };
      
      // 加载已保存的邮件配置
      this.loadEmailConfig();
    },
    
    // 加载邮件配置
    loadEmailConfig() {
      axios.get(`/api/email/config/${this.archiveId}`).then(response => {
        if (response.data.status === '10000' && response.data.data) {
          const savedConfig = response.data.data;
          // 合并保存的配置和默认配置
          this.emailConfig = {
            ...this.emailConfig,
            subject: savedConfig.subject || this.emailConfig.subject,
            content: savedConfig.content || this.emailConfig.content
          };
        }
      }).catch(err => {
        console.error('加载邮件配置失败', err);
      });
    },
    
    handleEmailDialogClosed() {
      this.emailConfig = {
        subject: '',
        content: '',
        archiveId: '',
        conferenceTitle: '',
        dateRangeText: '',
        city: '',
        addressDetails: '',
        taskContact: '',
        taskContactPhone: ''
      };
      this.emailTaskList = [];
      this.emailActiveTab = 'config';
    },
    
    handleEmailTabClick(tab) {
      if (tab.name === 'status') {
        this.refreshEmailTaskList();
      }
    },
    
    useDefaultEmailTemplate() {
      this.emailConfig.content = `微信搜索公众号：E健云，点击菜单“学术会议” 里的“我的信息”输入手机号获取您的活动安排。`;
      
      this.$message.info('邮件模板已更新为默认格式');
    },
    
    previewEmail() {
      if (!this.emailConfig.content) {
        this.$message.warning('请先输入邮件内容');
        return;
      }
      
      // 选择第一个嘉宾进行预览
      const guest = this.guestList[0];
      if (!guest) {
        this.$message.warning('没有可用的嘉宾数据进行预览');
        return;
      }
      
      const previewContent = this.generateGuestEmailContent(guest);
      this.$alert(previewContent, this.emailConfig.subject, {
        dangerouslyUseHTMLString: true,
        customClass: 'email-preview-dialog'
      });
    },
    
    generateGuestEmailContent(guest) {
      const shortGuestId = this.createShortId(guest._id);
      const shortArchiveId = this.createShortId(this.archiveId);
      
      return this.emailConfig.content
        .replace(/\${name}/g, guest.name || '')
        .replace(/\${title}/g, this.emailConfig.conferenceTitle || '')
        .replace(/\${time}/g, this.emailConfig.dateRangeText || '')
        .replace(/\${address}/g, this.emailConfig.city || '')
        .replace(/\${address_details}/g, this.emailConfig.addressDetails || '')
        .replace(/\${name1}/g, this.emailConfig.taskContact || '')
        .replace(/\${contacts}/g, this.emailConfig.taskContactPhone || '')
        .replace(/\${link}/g, shortGuestId)
        .replace(/\${link2}/g, shortArchiveId);
    },
    
    sendEmail() {
      if (this.selectedGuests.length === 0) {
        this.$message.warning('请选择至少一位嘉宾');
        return;
      }
      
      if (!this.emailConfig.subject || !this.emailConfig.content) {
        this.$message.warning('请输入邮件主题和内容');
        return;
      }
      
      // 过滤出有邮箱的嘉宾
      const validGuests = this.selectedGuests.filter(guest => guest.email);
      
      if (validGuests.length === 0) {
        this.$message.warning('选择的嘉宾中没有有效的邮箱地址');
        return;
      }
      
      // 确认发送
      this.$confirm(`确定要向${validGuests.length}位嘉宾发送邮件吗？`, '确认发送', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 构建发送数据
        const sendData = {
          config: this.emailConfig,
          guests: validGuests.map(guest => ({
            id: guest._id,
            name: guest.name,
            email: guest.email,
            schedules: guest.schedules,
            agendas: guest.agendas
          }))
        };
        
        this.sendingEmail = true;
        
        // 调用API发送邮件
        axios.post('/api/email/send', sendData).then(response => {
          this.sendingEmail = false;
          
          if (response.data.status === '10000') {
            this.$message.success(`邮件发送任务已创建，共${validGuests.length}封邮件`);
            this.emailDialogVisible = false;
          } else {
            this.$message.error(response.data.message || '发送失败');
          }
        }).catch(err => {
          this.sendingEmail = false;
          console.error('发送邮件失败', err);
          this.$message.error('发送邮件失败');
        });
      }).catch(() => {
        // 取消发送
      });
    },
    
    sendSingleEmail(guest) {
      if (!guest.email) {
        this.$message.warning('该嘉宾没有邮箱地址');
        return;
      }
      
      // 生成此嘉宾的个性化邮件内容
      const emailContent = this.generateGuestEmailContent(guest);
      
      // 确认发送
      this.$confirm(`确定要向 ${guest.name} 发送邮件吗？`, '确认发送', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 构建发送数据
        const sendData = {
          config: {
            ...this.emailConfig,
            content: emailContent
          },
          guests: [{
            id: guest._id,
            name: guest.name,
            email: guest.email,
            schedules: guest.schedules,
            agendas: guest.agendas
          }]
        };
        
        // 显示加载中
        const loading = this.$loading({
          lock: true,
          text: '正在发送邮件...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        // 调用API发送邮件
        axios.post('/api/email/send', sendData).then(response => {
          loading.close();
          
          if (response.data.status === '10000') {
            this.$message.success('邮件发送任务已创建');
          } else {
            this.$message.error(response.data.message || '发送失败');
          }
        }).catch(err => {
          loading.close();
          console.error('发送邮件失败', err);
          this.$message.error('发送邮件失败');
        });
      }).catch(() => {
        // 取消发送
      });
    },
    
    refreshEmailTaskList() {
      this.emailTaskLoading = true;
      axios.get(`/api/email/tasks/${this.archiveId}`).then(response => {
        this.emailTaskLoading = false;
        if (response.data.status === '10000') {
          this.emailTaskList = response.data.data;
        } else {
          this.$message.error(response.data.message || '获取任务列表失败');
        }
      }).catch(err => {
        this.emailTaskLoading = false;
        console.error('获取邮件任务列表失败', err);
        this.$message.error('获取任务列表失败');
      });
    },
    
    getEmailStatusType(status) {
      const statusMap = {
        'pending': 'info',
        'sending': 'warning',
        'sent': 'success',
        'failed': 'danger'
      };
      return statusMap[status] || 'info';
    },
    
    getEmailStatusText(status) {
      const statusMap = {
        'pending': '待发送',
        'sending': '发送中',
        'sent': '已发送',
        'failed': '发送失败'
      };
      return statusMap[status] || status;
    },
    
    resendEmail(task) {
      this.$confirm('确定要重新发送此邮件吗？', '确认重发', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post(`/api/email/resend/${task._id}`).then(response => {
          if (response.data.status === '10000') {
            this.$message.success('重发任务已创建');
            this.refreshEmailTaskList();
          } else {
            this.$message.error(response.data.message || '重发失败');
          }
        }).catch(err => {
          console.error('重发邮件失败', err);
          this.$message.error('重发失败');
        });
      }).catch(() => {
        // 取消重发
      });
    },
    
    // 保存邮件配置
    saveEmailConfig() {
      if (!this.emailConfig.subject || !this.emailConfig.content) {
        this.$message.warning('请填写完整的邮件配置');
        return;
      }
      
      // 调用API保存配置
      axios.post('/api/email/config', this.emailConfig).then(response => {
        if (response.data.status === '10000') {
          this.$message.success('邮件配置已保存');
        } else {
          this.$message.error(response.data.message || '保存失败');
        }
      }).catch(err => {
        console.error('保存邮件配置失败', err);
        this.$message.error('保存邮件配置失败');
      });
    },
    
    // 全选嘉宾
    selectAllGuests() {
      this.$refs.guestTable.toggleAllSelection();
    },
    
    // 处理嘉宾选择变化
    handleGuestSelectionChange(selection) {
      this.selectedGuests = selection;
    },
    
    // 在这里添加缺失的 stopPolling 方法
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
        console.log('主组件轮询已停止');
      }
    },

    formatDate,
    
    // 格式化日期显示
    formatDateDisplay(dateValue, format) {
      // 如果是ISO日期字符串，需要特殊处理
      if (typeof dateValue === 'string' && dateValue.includes('T')) {
        return formatDate(new Date(dateValue), format);
      }
      // 如果是普通日期字符串，如"2025-04-22"
      else if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return formatDate(new Date(dateValue), format);
      }
      // 如果已经是Date对象
      else if (dateValue instanceof Date) {
        return formatDate(dateValue, format);
      }
      // 其他情况，直接返回
      return dateValue || '';
    },
    
    // 格式化时间范围显示
    formatTimeRange(startTime, endTime) {
      if (!startTime || !endTime) return '';
      // 提取时间部分 (HH:mm)
      const start = typeof startTime === 'string' ? startTime.substring(0, 5) : startTime;
      const end = typeof endTime === 'string' ? endTime.substring(0, 5) : endTime;
      return `${start} - ${end}`;
    },
    
    // 检查设置状态
    async checkSetupStatus() {
      if (!this.archiveId) return;
      
      try {
        // 检查是否有场馆
        const venueRes = await getVenueList({ archiveId: this.archiveId, pageSize: 1 });
        this.hasVenues = venueRes.data && (
          (Array.isArray(venueRes.data) && venueRes.data.length > 0) || 
          (venueRes.data.records && venueRes.data.records.length > 0)
        );
        
        // 检查是否有日期
        const dateRes = await getDateList({ archiveId: this.archiveId, pageSize: 1 });
        this.hasDates = dateRes.data && (
          (Array.isArray(dateRes.data) && dateRes.data.length > 0) || 
          (dateRes.data.records && dateRes.data.records.length > 0)
        );
      } catch (error) {
        console.error('检查设置状态失败', error);
      }
    },
    
    // 处理导航命令
    handleCommand(command) {
      switch (command) {
        case 'venue':
          this.goToVenueManagement()
          break
        case 'date':
          this.goToDateManagement()
          break
      }
    },
    
    // 跳转到归档管理
    goToArchiveManagement() {
      this.$router.push({ path: '/mall/schedule' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    
    // 跳转到场馆管理
    goToVenueManagement() {
      this.$router.push({ 
        path: '/mall/schedule/venue',
        query: { 
          archiveId: this.archiveId,
          archiveName: this.archiveName
        }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    
    // 跳转到日期管理
    goToDateManagement() {
      this.$router.push({ 
        path: '/mall/schedule/date',
        query: { 
          archiveId: this.archiveId,
          archiveName: this.archiveName
        }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    
    // 日期格式化
      formatTime(time) {
        if (!time) return '';
        // 检查time是否为Date对象，如果是则转换为HH:mm格式
        if (time instanceof Date) {
          const hours = time.getHours().toString().padStart(2, '0');
          const minutes = time.getMinutes().toString().padStart(2, '0');
          return `${hours}:${minutes}`;
        }
        // 如果是字符串且包含:，则直接使用
        if (typeof time === 'string' && time.includes(':')) {
          return time.substring(0, 5); // 只返回HH:MM部分
        }
        // 安全返回
        return '';
      },
      
      // 格式化时间输入（支持不完整输入自动补零）
      formatTimeInput(input) {
        if (!input) return '';
        const cleaned = input.replace(/[^\d:]/g, '');
        const parts = cleaned.split(':');
        
        if (parts.length === 1) {
          // 只有小时部分
          const hour = parseInt(parts[0]) || 0;
          if (hour > 23) return '';
          return `${hour.toString().padStart(2, '0')}:00`;
        } else if (parts.length >= 2) {
          // 有小时和分钟部分
          const hour = parseInt(parts[0]) || 0;
          const minute = parseInt(parts[1]) || 0;
          if (hour > 23 || minute > 59) return '';
          return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        }
        
        return '';
      },
      
      // 处理开始时间输入
      handleStartTimeInput(value) {
        this.startTimeInput = value;
        this.updateTimeRange();
      },
      
      // 处理结束时间输入
      handleEndTimeInput(value) {
        this.endTimeInput = value;
        this.updateTimeRange();
      },
      
      // 更新timeRange以满足表单验证
      updateTimeRange() {
        const start = this.formatTimeInput(this.startTimeInput);
        const end = this.formatTimeInput(this.endTimeInput);
        
        if (start && end) {
          this.scheduleForm.timeRange = [start, end];
        } else if (start || end) {
          this.scheduleForm.timeRange = [start || '', end || ''];
        } else {
          this.scheduleForm.timeRange = null;
        }
      },
      
      // 失焦时格式化时间
      handleTimeBlur() {
        this.startTimeInput = this.formatTimeInput(this.startTimeInput);
        this.endTimeInput = this.formatTimeInput(this.endTimeInput);
        this.updateTimeRange();
        
        // 检查时间逻辑
        if (this.startTimeInput && this.endTimeInput && this.startTimeInput >= this.endTimeInput) {
          this.$message.warning('开始时间需早于结束时间');
        }
      },
    
    // 判断是否为奇数行（用于交替背景色）
    isOddRow(id) {
      if (!this.matrixData.venues) return false;
      const index = this.matrixData.venues.findIndex(item => item._id === id);
      return index % 2 === 0;
    },
    
    // 获取主题标签类型
    getThemeTagType(theme) {
      const themeMap = {
        'default': 'primary',
        'business': 'success',
        'tech': 'warning'
      };
      return themeMap[theme] || 'info';
    },
    
    // 获取主题显示文本
    getThemeText(theme) {
      const themeMap = {
        'default': '默认主题',
        'business': '商务主题',
        'tech': '科技主题'
      };
      return themeMap[theme] || theme;
    },
    
    // 获取日程矩阵数据
    async getScheduleMatrix() {
      if (!this.archiveId) {
        this.matrixData = { dates: [], venues: [], items: [] };
        return;
      }
      
      this.loading = true;
      try {
        console.log('开始获取日程矩阵数据，归档ID:', this.archiveId);
        
        // 1. 获取日期数据
        const dateParams = { archiveId: this.archiveId, pageSize: 100 };
        const dateRes = await getDateList(dateParams);
        console.log('日期数据响应:', dateRes);
        
        let dates = [];
        if (dateRes.status === '10000' || dateRes.code === 200) {
          if (dateRes.data && Array.isArray(dateRes.data)) {
            dates = dateRes.data.map(date => {
              // 确保日期格式正确
              const processedDate = {
                ...date,
                date: date.formattedDate || date.date // 优先使用formattedDate字段
              };
              
              // 生成日期名称 - 后端API不存储name字段，从formattedDate生成
              const dateParts = (processedDate.formattedDate || '').split('-');
              if (dateParts.length >= 3) {
                const month = dateParts[1];
                const day = dateParts[2];
                processedDate.name = `${month}-${day}`;
              } else {
                processedDate.name = this.formatDateDisplay(processedDate.date, 'MM-DD');
              }
              
              return processedDate;
            });
          } else if (dateRes.data && dateRes.data.records) {
            dates = (dateRes.data.records || []).map(date => {
              // 确保日期格式正确
              const processedDate = {
                ...date,
                date: date.formattedDate || date.date // 优先使用formattedDate字段
              };
              
              // 生成日期名称 - 后端API不存储name字段，从formattedDate生成
              const dateParts = (processedDate.formattedDate || '').split('-');
              if (dateParts.length >= 3) {
                const month = dateParts[1];
                const day = dateParts[2];
                processedDate.name = `${month}-${day}`;
              } else {
                processedDate.name = this.formatDateDisplay(processedDate.date, 'MM-DD');
              }
              
              return processedDate;
            });
          }
        }
        
        console.log('处理后的日期数据:', dates);
        
        // 2. 获取场馆数据
        const venueParams = { archiveId: this.archiveId, pageSize: 100 };
        const venueRes = await getVenueList(venueParams);
        console.log('场馆数据响应:', venueRes);
        
        let venues = [];
        if (venueRes.status === '10000' || venueRes.code === 200) {
          if (venueRes.data && Array.isArray(venueRes.data)) {
            venues = venueRes.data;
          } else if (venueRes.data && venueRes.data.records) {
            venues = venueRes.data.records || [];
          }
        }
        
        // 3. 获取日程数据
        const scheduleParams = {
          archiveId: this.archiveId,
          keyword: this.keywordSearch || undefined
        };
        
        if (this.dateRange && this.dateRange.length === 2) {
          scheduleParams.startDate = this.dateRange[0];
          scheduleParams.endDate = this.dateRange[1];
        }
        
        // 添加自定义过滤条件
        if (this.selectedDateId) {
          scheduleParams.dateId = this.selectedDateId;
        }
        
        if (this.selectedVenueId) {
          scheduleParams.venueId = this.selectedVenueId;
        }
        
        if (this.selectedCategory) {
          scheduleParams.category = this.selectedCategory;
        }
        
        const scheduleRes = await getScheduleList(scheduleParams);
        console.log('日程数据响应:', scheduleRes);
        
        let items = [];
        if (scheduleRes.status === '10000' || scheduleRes.code === 200) {
          if (scheduleRes.data && Array.isArray(scheduleRes.data)) {
            items = scheduleRes.data;
            // 这里记录一下数据结构，方便调试
            if (items.length > 0) {
              console.log('日程数据项示例:', items[0]);
              console.log('日程数据项dateId类型:', typeof items[0].dateId);
              console.log('日程数据项venueId类型:', typeof items[0].venueId);
            }
          } else if (scheduleRes.data && scheduleRes.data.records) {
            items = scheduleRes.data.records || [];
          }
        }
        
        // 4. 构建矩阵数据
        this.matrixData = {
          dates: dates,
          venues: venues,
          items: items
        };
        
        console.log('构建的矩阵数据:', this.matrixData);
        
        // 5. 更新状态
        this.hasVenues = venues.length > 0;
        this.hasDates = dates.length > 0;
        
        // 6. 如果没有数据，显示提示
        if (!this.hasVenues || !this.hasDates) {
          if (!this.hasVenues) {
            this.$message.warning('未获取到场馆数据，请先创建场馆');
          }
          if (!this.hasDates) {
            this.$message.warning('未获取到日期数据，请先创建日期');
          }
        }
      } catch (error) {
        console.error('获取日程矩阵数据失败', error);
        this.$message.error('获取日程矩阵数据失败: ' + (error.message || '未知错误'));
      } finally {
        this.loading = false;
      }
    },
    
    // 根据日期和会场获取日程项目
    getScheduleItemsByDateAndVenue(dateId, venueId) {
      // 尝试直接匹配，如果没有找到，再尝试在数组中查找
      const key = `${dateId}-${venueId}`;
      const items = this.scheduleItemsByDateAndVenue[key] || [];
      
      if (items.length > 0) {
        return items;
      }
      
      // 如果没有找到，可能是因为dateId和venueId的格式问题
      // 记录调试信息
      console.log(`尝试获取日程(${dateId}, ${venueId})，键值: ${key}`);
      console.log('可用键值:', Object.keys(this.scheduleItemsByDateAndVenue));
      
      return [];
    },
    
    // 获取日程项目样式类
    getScheduleItemClass(item) {
      const statusClasses = {
        draft: 'bg-gray-100 border border-gray-300',
        confirmed: 'bg-blue-50 border border-blue-200',
        cancelled: 'bg-red-50 border border-red-200 opacity-70',
        completed: 'bg-green-50 border border-green-200'
      }
      
      return statusClasses[item.status] || 'bg-white border'
    },
    
    // 获取状态标签类型
    getTagType(status) {
      const types = {
        draft: 'info',
        confirmed: 'primary',
        cancelled: 'danger',
        completed: 'success'
      }
      
      return types[status] || 'info'
    },
    
    // 获取状态文本
    getStatusText(status) {
      const texts = {
        draft: '草稿',
        confirmed: '已确认',
        cancelled: '已取消',
        completed: '已完成'
      }
      
      return texts[status] || '未知'
    },
    
    // 打开主题设置弹窗
    openThemeDialog() {
      this.themeDialogVisible = true;
      // 加载当前主题设置
      this.loadThemeSettings();
    },
    
    // 加载主题设置
    loadThemeSettings() {
      // 从localStorage加载保存的主题设置
      const savedTheme = localStorage.getItem(`schedule_theme_${this.archiveId}`);
      if (savedTheme) {
        this.themeForm.theme = savedTheme;
      } else {
        this.themeForm.theme = 'default';
      }
    },
    
    // 处理主题变更
    handleThemeChange(theme) {
      console.log('主题变更:', theme);
      // 可以在这里添加主题变更的实时预览效果
    },
    
    // 保存主题设置
    async saveThemeSettings() {
      this.themeSaving = true;
      try {
        // 检查是否有归档ID
        if (!this.archiveId) {
          this.$message.error('缺少归档ID，无法保存主题设置');
          return;
        }
        
        // 保存到localStorage（用于当前会话的即时预览）
        localStorage.setItem(`schedule_theme_${this.archiveId}`, this.themeForm.theme);
        
        // 调用API保存到服务器
        const res = await updateArchiveTheme({
          id: this.archiveId,
          themeStyle: this.themeForm.theme
        });
        
        if (res.status === '10000') {
          this.$message.success('主题设置保存成功');
          this.themeDialogVisible = false;
          
          // 应用主题到当前页面
          this.applyTheme(this.themeForm.theme);
        } else {
          throw new Error(res.message || '保存失败');
        }
        
      } catch (error) {
        console.error('保存主题设置失败:', error);
        this.$message.error(error.message || '保存主题设置失败');
      } finally {
        this.themeSaving = false;
      }
    },
    
    // 应用主题到页面
    applyTheme(theme) {
      // 移除之前的主题类
      document.body.classList.remove('schedule-theme-default', 'schedule-theme-modern', 'schedule-theme-elegant');
      
      // 添加新的主题类
      document.body.classList.add(`schedule-theme-${theme}`);
      
      // 这里可以添加更多主题应用逻辑
      console.log('应用主题:', theme);
    },
    
    // 主题弹窗关闭处理
    handleThemeDialogClose() {
      // 重置表单状态
      this.$refs.themeForm && this.$refs.themeForm.resetFields();
    },
    
    // 添加日程
    handleAddSchedule() {
      if (!this.hasVenues) {
        this.$message.warning('请先创建场馆')
        this.goToVenueManagement()
        return
      }
      
      if (!this.hasDates) {
        this.$message.warning('请先创建日期')
        this.goToDateManagement()
        return
      }
      
      this.openAddScheduleDialog();
    },
    
    // 打开添加日程对话框
    openAddScheduleDialog() {
      this.resetScheduleForm();
      this.scheduleForm.archiveId = this.archiveId;
      this.loadFormOptions();
      this.scheduleDialogVisible = true;
    },
    
    // 添加方法跳转到日程编辑页面
    goToAddSchedule() {
      this.$router.push({
        path: '/mall/schedule/edit',
        query: {
          archiveId: this.selectedArchiveId
        }
      })
    },
    
    // 加载表单选项
    async loadFormOptions() {
      this.scheduleFormLoading = true;
      try {
        // 加载日期选项
        const dateRes = await getDateList({ archiveId: this.archiveId, pageSize: 100 });
        if (dateRes.status === '10000' || dateRes.code === 200) {
          let dates = [];
          if (dateRes.data && Array.isArray(dateRes.data)) {
            dates = dateRes.data;
          } else if (dateRes.data && dateRes.data.records) {
            dates = dateRes.data.records || [];
          }
          
          this.dateOptions = dates.map(date => ({
            label: this.formatDateDisplay(date.date, 'YYYY-MM-DD'),
            value: date._id
          }));
        }
        
        // 加载会场选项
        const venueRes = await getVenueList({ archiveId: this.archiveId, pageSize: 100 });
        if (venueRes.status === '10000' || venueRes.code === 200) {
          let venues = [];
          if (venueRes.data && Array.isArray(venueRes.data)) {
            venues = venueRes.data;
          } else if (venueRes.data && venueRes.data.records) {
            venues = venueRes.data.records || [];
          }
          
          this.venueOptions = venues.map(venue => ({
            label: venue.name + (venue.location ? ` (${venue.location})` : ''),
            value: venue._id
          }));
        }
      } catch (error) {
        console.error('加载表单选项失败:', error);
        this.$message.error('加载表单选项失败');
      } finally {
        this.scheduleFormLoading = false;
      }
    },
    
    // 重置日程表单
    resetScheduleForm() {
      if (this.$refs.scheduleForm) {
        this.$refs.scheduleForm.resetFields();
      }
      
      this.scheduleForm = {
        _id: '',
        title: '',
        theme: '',
        dateId: '',
        venueId: '',
        archiveId: this.archiveId,
        timeRange: null,
        manager: '',
        contact: '',
        expectedAttendees: 0,
        status: '1', // 默认已确认
        description: '',
        // 新增字段
        sortOrder: 0,
        bannerImage: '',
        buttonText: '',
        buttonLink: '',
        richTextIntro: '',
        guests: []
      };
    },
    
    // 提交日程表单
    submitScheduleForm() {
      this.$refs.scheduleForm.validate(async valid => {
        if (!valid) return;
        
        this.submitLoading = true;
        try {
          // 准备提交数据
          const formData = {
            title: this.scheduleForm.title,
            theme: this.scheduleForm.theme || '',
            dateId: this.scheduleForm.dateId,
            venueId: this.scheduleForm.venueId,
            archiveId: this.archiveId,
            status: this.scheduleForm.status,
            manager: this.scheduleForm.manager || '',
            contact: this.scheduleForm.contact || '',
            expectedAttendees: this.scheduleForm.expectedAttendees || 0,
            description: this.scheduleForm.description || '',
            // 新增字段
            sortOrder: this.scheduleForm.sortOrder || 0,
            bannerImage: this.scheduleForm.bannerImage || '',
            buttonText: this.scheduleForm.buttonText || '',
            buttonLink: this.scheduleForm.buttonLink || '',
            richTextIntro: this.scheduleForm.richTextIntro || '',
            // 转换嘉宾数据格式
            guests: (this.scheduleForm.guests || []).map(g => ({
              guestId: g.guestId,
              role: g.role || '',
              sortOrder: g.sortOrder || 0
            }))
          };
          
          // 处理时间范围（timeRange 已为 'HH:mm' 字符串数组）
          if (this.scheduleForm.timeRange && this.scheduleForm.timeRange.length === 2) {
            formData.startTime = String(this.scheduleForm.timeRange[0]).substring(0,5);
            formData.endTime = String(this.scheduleForm.timeRange[1]).substring(0,5);
          }
          
          let res;
          if (this.scheduleForm._id) {
            // 编辑模式
            formData.id = this.scheduleForm._id;
            res = await updateSchedule(formData);
          } else {
            // 添加模式
            res = await addSchedule(formData);
          }
          
          // 处理响应
          if (res.code === 200 || res.status === '10000') {
            this.$message.success(this.scheduleForm._id ? '更新成功' : '添加成功');
            this.scheduleDialogVisible = false;
            
            // 刷新矩阵数据
            setTimeout(() => {
              this.getScheduleMatrix();
            }, 300);
          } else {
            this.$message.error(res.message || (this.scheduleForm._id ? '更新失败' : '添加失败'));
          }
        } catch (error) {
          console.error('提交日程表单失败:', error);
          this.$message.error('提交失败: ' + (error.message || '未知错误'));
        } finally {
          this.submitLoading = false;
        }
      });
    },
    
    // 快速添加日程（从矩阵单元格）
    handleQuickAdd(dateId, venueId) {
      console.log('快速添加参数:', { dateId, venueId });
      
      this.resetScheduleForm();
      this.scheduleForm.archiveId = this.archiveId;
      this.scheduleForm.dateId = dateId;
      this.scheduleForm.venueId = venueId;
      
      this.loadFormOptions();
      this.scheduleDialogVisible = true;
    },
    
    // 编辑日程
    async handleEditSchedule(item) {
      try {
        this.resetScheduleForm();
        
        // 先获取完整的日程详情数据（包含populated的嘉宾信息）
        const detailRes = await axios.get('/api/schedule/detail', {
          params: { 
            id: item._id || item.id,
            archiveId: this.archiveId
          }
        });
        
        let detailItem = item;
        if (detailRes && (detailRes.data.status === '10000' || detailRes.data.code === 200)) {
          detailItem = detailRes.data.data || item;
          console.log('获取到的详情数据:', detailItem);
        }
        
        // 设置表单数据
        this.scheduleForm = {
          _id: detailItem._id || detailItem.id,
          title: detailItem.title || '',
          theme: detailItem.theme || '',
          dateId: typeof detailItem.dateId === 'object' ? detailItem.dateId._id : detailItem.dateId,
          venueId: typeof detailItem.venueId === 'object' ? detailItem.venueId._id : detailItem.venueId,
          archiveId: this.archiveId,
          manager: detailItem.manager || '',
          contact: detailItem.contact || '',
          expectedAttendees: detailItem.expectedAttendees || 0,
          status: detailItem.status || '1',
          description: detailItem.description || '',
          // 新增字段
          sortOrder: detailItem.sortOrder || 0,
          bannerImage: detailItem.bannerImage || '',
          buttonText: detailItem.buttonText || '',
          buttonLink: detailItem.buttonLink || '',
          richTextIntro: detailItem.richTextIntro || '',
          guests: []
        };
        
        // 处理时间范围（字符串数组）
        if (detailItem.startTime && detailItem.endTime) {
          this.startTimeInput = String(detailItem.startTime).substring(0,5);
          this.endTimeInput = String(detailItem.endTime).substring(0,5);
          this.scheduleForm.timeRange = [
            this.startTimeInput,
            this.endTimeInput
          ];
        }
        
        // 处理嘉宾数据 - 使用详情API返回的完整数据
        if (detailItem.guests && detailItem.guests.length > 0) {
          console.log('处理嘉宾数据:', detailItem.guests);
          
          // 详情API已经填充了guestInfo，直接使用
          this.scheduleForm.guests = detailItem.guests.map(guest => ({
            guestId: guest.guestId,
            role: guest.role || '',
            sortOrder: guest.sortOrder || 0,
            guestInfo: guest.guestInfo || { 
              name: '未知嘉宾', 
              avatar: '', 
              company: '', 
              position: '' 
            }
          }));
          
          console.log('处理后的嘉宾数据:', this.scheduleForm.guests);
        }
        
        // 确保嘉宾列表已加载（用于添加新嘉宾）
        if (this.guestList.length === 0) {
          await this.getGuestList();
        }
        
        this.loadFormOptions();
        this.scheduleDialogVisible = true;
      } catch (error) {
        console.error('编辑日程失败:', error);
        this.$message.error('获取日程详情失败: ' + (error.message || '未知错误'));
      }
    },
    
    // 处理嘉宾数据
    processGuestData(item) {
      console.log('处理嘉宾数据:', item.guests);
      
      if (!item.guests || item.guests.length === 0) {
        this.scheduleForm.guests = [];
        return;
      }
      
      // 为每个嘉宾填充完整的 guestInfo
      this.scheduleForm.guests = item.guests.map(guest => {
        // 查找对应的嘉宾详细信息
        const guestInfo = this.guestList.find(g => 
          (g._id || g.id) === guest.guestId || 
          (g._id || g.id) === (guest.guestId?._id || guest.guestId?.id)
        );
        
        return {
          guestId: guest.guestId?._id || guest.guestId || guest.guestId,
          role: guest.role || '',
          sortOrder: guest.sortOrder || 0,
          guestInfo: guestInfo || guest.guestInfo || { 
            name: '未知嘉宾', 
            avatar: '', 
            company: '', 
            position: '' 
          }
        };
      });
      
      console.log('处理后的嘉宾数据:', this.scheduleForm.guests);
    },
    
    // 查看日程项目
    handleViewSchedule(item) {
      console.log('查看日程项目:', item);
      
      if (!item) {
        this.$message.error('日程数据无效');
        return;
      }
      
      // 创建一个新对象，避免修改原始数据
      const scheduleItem = { ...item };
      
      // 获取会场信息
      if (scheduleItem.venueId) {
        const venue = this.matrixData.venues.find(v => 
          v._id === scheduleItem.venueId || 
          (typeof scheduleItem.venueId === 'object' && v._id === scheduleItem.venueId._id)
        );
        
        if (venue) {
          scheduleItem.venueName = venue.name;
        }
      }
      
      // 获取日期信息
      if (scheduleItem.dateId) {
        const date = this.matrixData.dates.find(d => 
          d._id === scheduleItem.dateId || 
          (typeof scheduleItem.dateId === 'object' && d._id === scheduleItem.dateId._id)
        );
        
        if (date) {
          scheduleItem.date = date.date;
        }
      }
      
      // 设置默认值
      scheduleItem.category = scheduleItem.category || 'test';
      scheduleItem.agendaCount = scheduleItem.agendaCount || 0;
      
      this.currentSchedule = scheduleItem;
      this.scheduleDetailVisible = true;
    },
    
    // 导出日程表（CSV格式）
    exportSchedule() {
      if (!this.matrixData.dates || this.matrixData.dates.length === 0) {
        this.$message.warning('暂无数据可导出')
        return
      }
      
      try {
        this.$message.info('正在生成导出文件，请稍候...')
        
        // 添加标题行
        let csvContent = '';
        if (this.archiveName) {
          csvContent += `# 归档: ${this.archiveName}\n`;
          csvContent += `# 导出时间: ${formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')}\n`;
          csvContent += `# 包含 ${this.matrixData.dates.length} 个日期, ${this.matrixData.venues.length} 个场馆\n\n`;
        }
        
        // 创建CSV内容
        const headers = ['场馆', '位置', '日期', '时间', '标题', '主题', '负责人', '联系方式', '状态']
        csvContent += headers.join(',') + '\n'
        
        // 构建数据
        const items = []
        this.matrixData.venues.forEach(venue => {
          this.matrixData.dates.forEach(date => {
            const scheduleItems = this.getScheduleItemsByDateAndVenue(date._id, venue._id)
            
            if (scheduleItems.length === 0) {
              items.push({
                venue: venue.name,
                location: venue.location || '',
                date: this.formatDateDisplay(date.date, 'YYYY-MM-DD'),
                time: '',
                title: '(无安排)',
                theme: '',
                manager: '',
                contact: '',
                status: ''
              })
            } else {
              scheduleItems.forEach(item => {
                items.push({
                  venue: venue.name,
                  location: venue.location || '',
                  date: this.formatDateDisplay(date.date, 'YYYY-MM-DD'),
                  time: `${item.startTime}-${item.endTime}`,
                  title: item.title,
                  theme: item.theme || '',
                  manager: item.manager || '',
                  contact: item.contact || '',
                  status: this.getStatusText(item.status)
                })
              })
            }
          })
        })
        
        // 将数据转为CSV行
        items.forEach(item => {
          const row = [
            this.escapeCsvValue(item.venue),
            this.escapeCsvValue(item.location),
            this.escapeCsvValue(item.date),
            this.escapeCsvValue(item.time),
            this.escapeCsvValue(item.title),
            this.escapeCsvValue(item.theme),
            this.escapeCsvValue(item.manager),
            this.escapeCsvValue(item.contact),
            this.escapeCsvValue(item.status)
          ]
          csvContent += row.join(',') + '\n'
        })
        
        // 创建blob并下载
        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        
        // 生成文件名
        const archiveName = this.archiveName || '日程表'
        const fileName = `${archiveName}-日程表-${formatDate(new Date(), 'YYYYMMDD')}.csv`
        
        // 处理下载
        if (window.navigator.msSaveOrOpenBlob) {
          // IE浏览器
          window.navigator.msSaveOrOpenBlob(blob, fileName)
        } else {
          // 其他浏览器
          const url = URL.createObjectURL(blob)
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
        
        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出日程表失败', error)
        this.$message.error('导出日程表失败')
      }
    },
    
    // CSV值转义（处理逗号、引号等特殊字符）
    escapeCsvValue(value) {
      if (value === null || value === undefined) return ''
      value = String(value)
      if (value.includes(',') || value.includes('"') || value.includes('\n')) {
        // 将引号转义为双引号并用引号包围整个字符串
        return '"' + value.replace(/"/g, '""') + '"'
      }
      return value
    },
    
    // 返回归档管理
    goBack() {
      this.goToArchiveManagement()
    },
    
    // 编辑日期
    handleEditDate(date) {
      this.addDateForm = {
        archiveId: this.archiveId,
        _id: date._id,
        date: new Date(date.date.replace(/-/g, '/'))
      };
      this.addDateDialogVisible = true;
    },
    
    // 删除日期
    handleDeleteDate(date) {
      this.$confirm('确定要删除此日期吗？删除后相关日程将无法显示', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const deleteParams = { id: date._id }; // 使用id作为参数
          console.log('删除日期参数:', deleteParams);
          const res = await deleteDate(deleteParams);
          if (res.code === 200 || res.status === '10000') {
            this.$message.success('删除成功');
            this.getScheduleMatrix();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        } catch (error) {
          console.error('删除日期失败:', error);
          this.$message.error('删除操作失败: ' + (error.message || '未知错误'));
        }
      }).catch(() => {
        // 取消删除
      });
    },
    
    // 编辑会场
    handleEditVenue(venue) {
      this.addVenueForm = {
        archiveId: this.archiveId,
        _id: venue._id,
        name: venue.name,
        image: venue.image || ''
      };
      this.addVenueDialogVisible = true;
    },
    
    // 删除会场
    handleDeleteVenue(venue) {
      this.$confirm('确定要删除此会场吗？删除后相关日程将无法显示', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const deleteParams = { id: venue._id }; // 使用id作为参数
          console.log('删除会场参数:', deleteParams);
          const res = await deleteVenue(deleteParams);
          if (res.code === 200 || res.status === '10000') {
            this.$message.success('删除成功');
            this.getScheduleMatrix();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        } catch (error) {
          console.error('删除会场失败:', error);
          this.$message.error('删除操作失败: ' + (error.message || '未知错误'));
        }
      }).catch(() => {
        // 取消删除
      });
    },
    
    // 处理日期筛选
    handleDateFilter(dateId) {
      this.selectedDateId = dateId;
      // 这里可以实现筛选逻辑，或者仅在前端过滤显示
    },
    
    // 处理会场筛选
    handleVenueFilter(venueId) {
      this.selectedVenueId = venueId;
      // 这里可以实现筛选逻辑，或者仅在前端过滤显示
    },
    
    // 处理分类筛选
    handleCategoryFilter(category) {
      this.selectedCategory = category;
      // 这里可以实现筛选逻辑，或者仅在前端过滤显示
    },
    
    // 打开添加日期对话框
    openAddDateDialog() {
      this.addDateForm = {
        archiveId: this.archiveId,
        _id: '',
        date: null
      };
      this.addDateDialogVisible = true;
    },
    
    // 提交添加日期
    async submitAddDate() {
      this.$refs.addDateForm.validate(async (valid) => {
        if (valid) {
          this.addDateLoading = true;
          try {
            // 格式化日期为yyyy-MM-dd格式
            let formData = {
              archiveId: this.addDateForm.archiveId
            };
            
            if (this.addDateForm.date instanceof Date) {
              const year = this.addDateForm.date.getFullYear();
              const month = String(this.addDateForm.date.getMonth() + 1).padStart(2, '0');
              const day = String(this.addDateForm.date.getDate()).padStart(2, '0');
              formData.date = `${year}-${month}-${day}`;
            } else if (typeof this.addDateForm.date === 'string') {
              formData.date = this.addDateForm.date;
            }
            
            // 根据是否有ID判断是添加还是编辑
            const isEdit = !!this.addDateForm._id;
            let res;
            
            if (isEdit) {
              // 后端API期望的参数是id而不是_id，需要转换
              formData.id = this.addDateForm._id; // 将_id复制为id字段
              
              console.log('编辑日期参数:', formData);
              res = await editDate(formData);
            } else {
              // 添加日期 - 只使用后端支持的字段
              console.log('添加日期参数:', formData);
              res = await addDate(formData);
            }
            
            if (res.code === 200 || res.status === '10000') {
              this.$message.success(isEdit ? '编辑日期成功' : '添加日期成功');
              this.addDateDialogVisible = false;
              // 重新加载矩阵数据
              this.getScheduleMatrix();
            } else {
              this.$message.error(res.message || (isEdit ? '编辑日期失败' : '添加日期失败'));
            }
          } catch (error) {
            console.error('保存日期失败:', error);
            this.$message.error('保存日期失败: ' + (error.message || '未知错误'));
          } finally {
            this.addDateLoading = false;
          }
        }
      });
    },
    
    // 打开添加会场对话框
    openAddVenueDialog() {
      this.addVenueForm = {
        archiveId: this.archiveId,
        _id: '',
        name: '',
        image: ''
      };
      this.addVenueDialogVisible = true;
    },
    
    // 提交添加会场
    async submitAddVenue() {
      this.$refs.addVenueForm.validate(async (valid) => {
        if (valid) {
          this.addVenueLoading = true;
          try {
            // 根据是否有ID判断是添加还是编辑
            const isEdit = !!this.addVenueForm._id;
            let res;
            
            if (isEdit) {
              // 后端API期望的参数是id而不是_id，需要转换
              const editParams = {
                ...this.addVenueForm,
                id: this.addVenueForm._id // 将_id复制为id字段
              };
              delete editParams._id; // 删除_id字段，避免混淆
              
              console.log('编辑会场参数:', editParams);
              res = await editVenue(editParams);
            } else {
              res = await addVenue(this.addVenueForm);
            }
            
            if (res.code === 200 || res.status === '10000') {
              this.$message.success(isEdit ? '编辑会场成功' : '添加会场成功');
              this.addVenueDialogVisible = false;
              // 重新加载矩阵数据
              this.getScheduleMatrix();
            } else {
              this.$message.error(res.message || (isEdit ? '编辑会场失败' : '添加会场失败'));
            }
          } catch (error) {
            console.error('保存会场失败:', error);
            this.$message.error('保存会场失败: ' + (error.message || '未知错误'));
          } finally {
            this.addVenueLoading = false;
          }
        }
      });
    },
    
    // 打开添加分类对话框
    openAddCategoryDialog() {
      this.addCategoryForm = {
        name: ''
      };
      this.addCategoryDialogVisible = true;
    },
    
    // 提交添加分类
    async submitAddCategory() {
      this.$refs.addCategoryForm.validate(async (valid) => {
        if (valid) {
          this.addCategoryLoading = true;
          try {
            // 这里应该调用添加分类的API
            // 目前仅模拟添加到本地数组
            this.categoryOptions.push({
              label: this.addCategoryForm.name,
              value: this.addCategoryForm.name
            });
            this.$message.success('添加分类成功');
            this.addCategoryDialogVisible = false;
          } catch (error) {
            console.error('添加分类失败:', error);
            this.$message.error('添加分类失败: ' + (error.message || '未知错误'));
          } finally {
            this.addCategoryLoading = false;
          }
        }
      });
    },
    
    // 获取归档选项
    async getArchiveOptions() {
      try {
        const res = await getArchiveList({ pageSize: 100 });
        console.log('获取归档选项响应:', res);
        
        // 如果没有选择归档但有数据，默认选择第一个
        if (!this.archiveId && res.data && res.data.records && res.data.records.length > 0) {
          const firstArchive = res.data.records[0];
          this.archiveId = firstArchive._id || firstArchive.id;
          this.archiveName = firstArchive.name;
          console.log('自动选择首个归档:', this.archiveId, this.archiveName);
        }
      } catch (error) {
        console.error('获取归档选项失败:', error);
        this.$message.error('获取归档选项失败: ' + (error.message || '未知错误'));
      }
    },
    
    // 获取分类选项
    async getCategoryOptions() {
      try {
        // 模拟获取分类选项
        this.categoryOptions = [
          { label: '会议', value: 'meeting' },
          { label: '演讲', value: 'speech' },
          { label: '工作坊', value: 'workshop' },
          { label: '休息', value: 'break' }
        ];
      } catch (error) {
        console.error('获取分类选项出错:', error);
        this.$message.error('获取分类选项失败');
      }
    },
    
    // 处理关键词搜索
    handleKeywordSearch() {
      this.getScheduleMatrix();
    },
    
    // 处理分类变更
    handleCategoryChange() {
      this.getScheduleMatrix();
    },
    
    // 添加嘉宾相关方法
    // 获取嘉宾列表
    getGuestList(params = {}) {
      this.guestLoading = true;
      
      const queryParams = {
        pageSize: params.pageSize || this.pageSize,
        page: params.page || this.currentPage,
        // 确保使用正确的参数名 search 和组件数据 guestKeyword
        search: this.guestKeyword || undefined, // 如果 guestKeyword 为空，则不传递该参数或传递 undefined
        category: this.guestCategoryFilter || undefined,
        archiveId: this.archiveId
      };
      
      return getGuestList(queryParams)
        .then(res => {
          if (res.status === '10000') {
            if (res.data && Array.isArray(res.data) && res.pagination) { // 优先检查带 pagination 的结构
              this.guestList = res.data;
              this.total = res.pagination.total || 0;
              // 可以选择性地从后端更新当前页和大小
              // this.currentPage = res.pagination.currentPage || this.currentPage;
              // this.pageSize = res.pagination.pageSize || this.pageSize;
            } else if (res.data && res.data.records && res.data.total !== undefined) { // 检查 data 包含 records 和 total 的结构
              this.guestList = res.data.records;
              this.total = res.data.total || 0;
              // 可以选择性地从后端更新当前页和大小
              // this.currentPage = res.data.current || this.currentPage;
              // this.pageSize = res.data.size || this.pageSize;
            } else if (res.data && Array.isArray(res.data)) { // 如果没有分页信息，假设返回了全部数据
              console.warn('getGuestList API 未返回分页信息，将尝试前端分页或显示全部。');
              this.guestList = res.data;
              this.total = res.data.length;
              this.currentPage = 1; // 重置为第一页
            } else {
              // 处理未知响应格式
              console.warn("getGuestList 响应格式未知或无效:", res);
              this.guestList = [];
              this.total = 0;
            }
          } else {
            // 处理 API 错误状态
            this.guestList = [];
            this.total = 0;
            this.$message.error(res.message || '获取嘉宾列表失败');
          }
          // 补充分组名称，供列表展示
          if (Array.isArray(this.guestList)) {
            this.guestList.forEach(guest => {
              guest.categoryName = this.guestCategoryMap[guest.category] || '';
            });
          }
          // 不再返回 res，因为后续逻辑可能不再需要原始响应
        })
        .catch(err => {
          console.error('获取嘉宾列表失败:', err);
          this.$message.error('获取嘉宾列表失败');
          // 确保即使出错也重置状态
          this.guestList = [];
          this.total = 0;
        })
        .finally(() => {
          this.guestLoading = false;
        });
    },
    
    // 显示嘉宾选择对话框
    async showGuestSelector() {
      if (this.guestCategoryOptions.length === 0) {
        await this.loadGuestCategories()
      }
      if (this.guestList.length === 0) {
        await this.getGuestList()
      }
      
      // 预选已添加的嘉宾
      this.selectedGuests = []
      this.guestDialogVisible = true
    },

    // 加载嘉宾分组，用于筛选和展示
    async loadGuestCategories() {
      try {
        const res = await getGuestCategories()
        if (res.status === '10000') {
          const list = (res.data && res.data.categories) || []
          this.guestCategoryOptions = list
          const map = {}
          list.forEach(c => { map[c._id] = c.name })
          this.guestCategoryMap = map
          if (Array.isArray(this.guestList)) {
            this.guestList.forEach(g => { g.categoryName = map[g.category] || '' })
          }
        }
      } catch (e) {
        console.error('获取嘉宾分组失败:', e)
      }
    },

    // 分组筛选变化时刷新列表
    handleGuestCategoryChange() {
      this.currentPage = 1
      this.getGuestList()
    },
    
    // 处理嘉宾选择变化
    handleGuestSelectionChange(selection) {
      this.selectedGuests = selection || [];
    },
    
    // 确认嘉宾选择
    confirmGuestSelection() {
      console.log('已选嘉宾:', this.selectedGuests);
      
      // 获取已选嘉宾的ID列表
      const existingGuestIds = this.scheduleForm.guests.map(g => g.guestId);
      
      // 添加新选择的嘉宾（去重）
      this.selectedGuests.forEach(guest => {
        const guestId = guest._id || guest.id;
        if (!existingGuestIds.includes(guestId)) {
          this.scheduleForm.guests.push({
            guestId,
            role: '',
            sortOrder: this.scheduleForm.guests.length,
            guestInfo: guest
          });
        }
      });
      
      console.log('更新后的嘉宾列表:', this.scheduleForm.guests);
      this.guestDialogVisible = false;
    },
    
    // 移除已添加的嘉宾
    removeGuest(index) {
      this.scheduleForm.guests.splice(index, 1)
    },
    
    // 处理Banner上传成功
    handleBannerSuccess(res, type) {
      console.log('Banner上传响应:', res);
      // 新的API返回格式为 { data: "图片URL", errorCode: "00000", message: "请求成功" }
      if (res.errorCode === "00000" && res.data) {
        this.smsConfig[type] = res.data;
        this.$message.success('上传成功');
      } else if (res.url) {
        // 兼容旧版本API
        this.smsConfig[type] = res.url;
        this.$message.success('上传成功');
      } else {
        this.$message.error('上传失败: ' + (res.message || '未知错误'));
      }
    },
    
    // 上传前验证
    beforeBannerUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return false
      }
      
      return true
    },
    
    // 删除日程项目
    handleDeleteSchedule(item) {
      this.$confirm('确定要删除此日程吗？删除后将无法恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const deleteParams = { id: item._id || item.id };
          console.log('删除日程参数:', deleteParams);
          const res = await deleteSchedule(deleteParams);
          if (res.code === 200 || res.status === '10000') {
            this.$message.success('删除成功');
            this.getScheduleMatrix();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        } catch (error) {
          console.error('删除日程失败:', error);
          this.$message.error('删除操作失败: ' + (error.message || '未知错误'));
        }
      }).catch(() => {
        // 取消删除
      });
    },
    
    // 打开日程详情浮层
    openScheduleDetail(item) {
      this.currentSchedule = item;
      this.scheduleDetailVisible = true;
    },
    
    // 处理链接点击
    openScheduleLink(url) {
      if (!url) return;
      
      if (url.startsWith('http://') || url.startsWith('https://')) {
        window.open(url, '_blank');
      } else {
        // 内部路由或其他处理
        this.$message.info('正在跳转到: ' + url);
      }
    },
    
    // 编辑日程
    handleEditSchedule(item) {
      this.resetScheduleForm();
      
      // 设置表单数据
      this.scheduleForm = {
        _id: item._id || item.id,
        title: item.title || '',
        theme: item.theme || '',
        dateId: typeof item.dateId === 'object' ? item.dateId._id : item.dateId,
        venueId: typeof item.venueId === 'object' ? item.venueId._id : item.venueId,
        archiveId: this.archiveId,
        manager: item.manager || '',
        contact: item.contact || '',
        expectedAttendees: item.expectedAttendees || 0,
        status: item.status || '1',
        description: item.description || '',
        // 新增字段
        sortOrder: item.sortOrder || 0,
        bannerImage: item.bannerImage || '',
        buttonText: item.buttonText || '',
        buttonLink: item.buttonLink || '',
        richTextIntro: item.richTextIntro || '',
        guests: []
      };
      
      // 处理时间范围（字符串数组）
      if (item.startTime && item.endTime) {
        this.startTimeInput = String(item.startTime).substring(0,5);
        this.endTimeInput = String(item.endTime).substring(0,5);
        this.scheduleForm.timeRange = [
          this.startTimeInput,
          this.endTimeInput
        ];
      }
      
      // 处理嘉宾数据
      if (item.guests && item.guests.length > 0) {
        // 确保我们有嘉宾列表数据
        if (this.guestList.length === 0) {
          this.getGuestList().then(() => {
            this.processGuestData(item);
          });
        } else {
          this.processGuestData(item);
        }
      }
      
      this.loadFormOptions();
      this.scheduleDialogVisible = true;
    },
    
    // 跳转到议程页面
    goToAgendaPage(schedule) {
      if (!schedule || !schedule._id) {
        this.$message.error('日程数据无效');
        return;
      }
      
      // 跳转到日程详情页的议程选项卡
      this.$router.push({
        path: '/mall/schedule/detail',
        query: { 
          id: schedule._id,
          tab: 'agenda'
        }
      });
    },
    
    // 查看日程详情
    handleViewScheduleDetail(schedule) {
      if (!schedule || !schedule._id) {
        this.$message.error('日程数据无效');
        return;
      }
      
      // 跳转到日程详情页
      this.$router.push({
        path: '/mall/schedule/detail',
        query: { 
          id: schedule._id,
          tab: 'info'
        }
      });
    },
    loadGuests() {
      this.guestLoading = true;
      
      // 调用API获取嘉宾列表（包含日程和议程）
      getGuestListWithSchedules({
        page: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.guestSearchKeyword,
        archiveId: this.archiveId
      }).then(res => {
        if (res.status === '10000') {
          // 已经包含完整的日程和议程信息，直接使用
          this.guestList = res.data;
          this.total = res.pagination.total || 0;
        } else {
          this.$message.error(res.message || '获取嘉宾列表失败');
        }
      }).catch(err => {
        console.error('获取嘉宾列表失败', err);
        this.$message.error('获取嘉宾列表失败');
      }).finally(() => {
        this.guestLoading = false;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 页大小改变时，通常返回第一页
      // 选择嘉宾弹窗分页，保持与初始化一致，统一使用 getGuestList 接口
      if (this.guestDialogVisible) {
        this.getGuestList();
      } else {
        // 其他场景（如短信/邮件预览）沿用包含日程信息的接口
        this.loadGuests();
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.guestDialogVisible) {
        this.getGuestList();
      } else {
        this.loadGuests();
      }
    },
    getVenueName(venueId) {
      const venue = this.matrixData.venues.find(v => v._id === venueId);
      return venue ? venue.name : '';
    },
    previewSms() {
      try {
        if (!this.smsConfig.content) {
          this.$message.warning('请先设置短信内容');
          return;
        }
        
        // 从当前嘉宾列表中获取一个嘉宾进行预览（优先使用选中的嘉宾）
        let previewGuest = null;
        
        if (this.selectedGuests && this.selectedGuests.length > 0) {
          previewGuest = this.selectedGuests[0];
        } else if (this.guestList && this.guestList.length > 0) {
          previewGuest = this.guestList[0];
        }
        
        if (!previewGuest) {
          this.$message.warning('请先选择嘉宾或加载嘉宾列表');
          return;
        }
        
        // 构建预览数据
        const previewData = {
          guest: previewGuest,
          topBanner: this.smsConfig.topBanner,
          content: this.generateGuestSmsContent(previewGuest),
          bottomBanner: this.smsConfig.bottomBanner
        };
        
        // 构建预览URL，使用真实的链接网站URL
        let linkParam = '';
        if (previewGuest._id) {
          linkParam += `guestId=${previewGuest._id}`;
        }
        if (this.archiveId) {
          linkParam += (linkParam ? '&' : '') + `archiveId=${this.archiveId}`;
        }
        
        // 设置预览URL，直接使用网站真实地址
        this.previewUrl = `https://fankeymice.com/#/pages/index/sms?${linkParam}`;
        
        // 打开预览对话框
        this.previewDialogVisible = true;
      } catch (error) {
        console.error('预览生成失败:', error);
        this.$message.error('预览生成失败，请检查内容中是否包含特殊字符');
      }
    },
    sendSms() {
      if (this.selectedGuests.length === 0) {
        this.$message.warning('请选择至少一位嘉宾');
        return;
      }
      
      if (!this.smsConfig.content) {
        this.$message.warning('请输入短信内容');
        return;
      }
      
      // 过滤出有手机号的嘉宾
      const validGuests = this.selectedGuests.filter(guest => guest.phone);
      
      if (validGuests.length === 0) {
        this.$message.warning('选择的嘉宾中没有有效的手机号');
        return;
      }
      
      // 确认发送
      this.$confirm(`确定要向${validGuests.length}位嘉宾发送短信吗？`, '确认发送', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 构建发送数据
        const sendData = {
          config: this.smsConfig,
          guests: validGuests.map(guest => ({
            id: guest._id,
            name: guest.name,
            phone: guest.phone,
            schedules: guest.schedules,
            agendas: guest.agendas
          }))
        };
        
        // 显示加载中
        const loading = this.$loading({
          lock: true,
          text: '正在发送短信...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        // 调用API发送短信
        axios.post('/api/sms/send', sendData).then(response => {
          loading.close();
          
          if (response.data.status === '10000') {
            this.$message.success(`短信发送成功，共发送${validGuests.length}条短信`);
            this.smsDialogVisible = false;
          } else {
            this.$message.error(response.data.message || '发送失败');
          }
        }).catch(err => {
          loading.close();
          console.error('发送短信失败', err);
          this.$message.error('发送短信失败');
        });
      }).catch(() => {
        // 取消发送
      });
    },
    formatDate(dateId) {
      if (!dateId || !this.matrixData || !this.matrixData.dates) {
        return '';
      }
      
      const date = this.matrixData.dates.find(d => d._id === dateId);
      
      if (date && date.date) {
        // 将日期格式化为MM-DD
        return formatDateByType(date.date, 'short');
      }
      
      return '';
    },
    beforeBannerUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isImage) {
        this.$message.error('只能上传图片文件');
        return false;
      }
      
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB');
        return false;
      }
      
      return true;
    },
    // 打开短信发送对话框
    openSmsDialog() {
      this.smsDialogVisible = true;
      this.loadGuests();
    },
    // 打开短信预览对话框
    openPreviewDialog() {
      this.previewDialogVisible = true;
    },
    useDefaultTemplate() {
      // 设置默认短信模板，使用最新格式
      this.smsConfig.content = '微信搜索公众号：E健云，点击菜单“学术会议” 里的“我的信息”输入手机号获取您的活动安排。';
      
      // 提示用户链接格式
      this.$message.info('短信模板已更新为最新格式');
    },
    updateSmsContent() {
      // 根据填写的变量生成完整的短信内容，保留原始变量占位符
      this.smsConfig.content = `微信搜索公众号：E健云，点击菜单“学术会议” 里的“我的信息”输入手机号获取您的活动安排。`;
    },
    previewGuestSms(guest) {
      if (!guest || !guest.name) {
        this.$message.warning('嘉宾信息不完整');
        return;
      }
      
      // 生成此嘉宾的个性化短信内容
      const smsContent = this.generateGuestSmsContent(guest);
      
      // 构建预览数据
      const previewData = {
        topBanner: this.smsConfig.topBanner,
        content: smsContent,
        bottomBanner: this.smsConfig.bottomBanner,
        guest: guest
      };
      
      // 打开短信预览对话框
      this.currentPreviewSms = {
        guest,
        content: smsContent
      };
      this.smsPreviewDialogVisible = true;
    },
    
    sendSingleSms(guest) {
      if (!guest.phone) {
        this.$message.warning('该嘉宾没有手机号码');
        return;
      }
      
      // 生成此嘉宾的个性化短信内容
      const smsContent = this.generateGuestSmsContent(guest);
      
      // 确认发送
      this.$confirm(`确定要向 ${guest.name} 发送短信吗？`, '确认发送', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 构建发送数据
        const sendData = {
          config: {
            ...this.smsConfig,
            content: smsContent
          },
          guests: [{
            id: guest._id,
            name: guest.name,
            phone: guest.phone,
            schedules: guest.schedules,
            agendas: guest.agendas
          }]
        };
        
        // 显示加载中
        const loading = this.$loading({
          lock: true,
          text: '正在发送短信...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        // 调用API发送短信
        axios.post('/api/sms/send', sendData).then(response => {
          loading.close();
          
          if (response.data.status === '10000') {
            this.$message.success(`短信发送成功`);
          } else {
            this.$message.error(response.data.message || '发送失败');
          }
        }).catch(err => {
          loading.close();
          console.error('发送短信失败', err);
          this.$message.error('发送短信失败');
        });
      }).catch(() => {
        // 取消发送
      });
    },
    
    generateGuestSmsContent(guest) {
      // 从模板内容生成个性化短信
      let content = this.smsConfig.content || '';
      
      // 替换变量
      if (guest) {
        // 嘉宾基本信息替换
        const name = guest.name || '';
        let position = guest.position ? ` ${guest.position}` : '';
        
        // 嘉宾日程信息
        const firstSchedule = guest.schedules && guest.schedules.length > 0 ? guest.schedules[0] : null;
        let dateStr = '';
        let venueStr = '';
        let venueLocation = '';
        let title = '';
        let timeStr = '';
        
        if (firstSchedule) {
          // 日期和时间信息
          const date = this.matrixData.dates.find(d => d._id === firstSchedule.dateId);
          dateStr = date ? formatDateByType(date.date, 'full') : '';
          timeStr = `${dateStr} ${firstSchedule.startTime}-${firstSchedule.endTime}`;
          
          // 场馆信息
          const venue = this.matrixData.venues.find(v => v._id === firstSchedule.venueId);
          venueStr = venue ? venue.name : '';
          venueLocation = venue && venue.location ? venue.location : '';
          
          // 会议标题
          title = firstSchedule.title || '';
        }
        
        // 使用会议标题的值
        const conferenceTitle = this.smsConfig.conferenceTitle || '';
        
        // 使用城市的值
        const city = this.smsConfig.city || '';
        
        // 链接参数
        const guestId = guest._id || '';
        const archiveId = this.archiveId || '';
        
        // 联系人信息
        const taskContactName = this.smsConfig.taskContact || '';
        const taskContactPhone = this.smsConfig.taskContactPhone || '';
        const eventContactName = this.smsConfig.eventContact || '';
        const eventContactPhone = this.smsConfig.eventContactPhone || '';
        const addressDetails = this.smsConfig.addressDetails || '';
        
        // 替换所有变量
        content = content
          .replace(/\${name}/g, name)
          .replace(/\${position}/g, position)
          .replace(/\${conferenceTitle}/g, conferenceTitle) // 使用conferenceTitle替代title
          .replace(/\${time}/g, timeStr)
          .replace(/\${address}/g, city) // 使用city替代venue名称
          .replace(/\${address_details}/g, addressDetails || venueLocation)
          .replace(/\${link}/g, guestId)
          .replace(/\${link2}/g, archiveId)
          .replace(/\${name1}/g, taskContactName)
          .replace(/\${contacts}/g, taskContactPhone)
          .replace(/\${name2}/g, eventContactName)
          .replace(/\${contacts2}/g, eventContactPhone);
      }
      
      return content;
    },
    generateAllSmsList() {
      if (!this.smsConfig.content) {
        this.$message.warning('请先设置短信内容模板');
        return;
      }

      this.smsListLoading = true;
      
      // 检查是否有嘉宾
      if (!this.guestList || this.guestList.length === 0) {
        this.loadGuests().then(() => {
          this.processSmsListData();
        });
      } else {
        this.processSmsListData();
      }
    },
    
    processSmsListData() {
      // 为每个嘉宾生成个性化短信内容
      this.smsListData = this.guestList.map(guest => {
        return {
          guest,
          content: this.generateGuestSmsContent(guest),
          status: guest.phone ? 'pending' : 'disabled'
        };
      });
      
      this.smsListLoading = false;
      this.smsListDialogVisible = true;
    },
    
    previewSmsListItem(item) {
      this.currentPreviewSms = {
        guest: item.guest,
        content: item.content
      };
      this.smsPreviewDialogVisible = true;
    },
    
    sendSmsListItem(item) {
      if (!item.guest.phone) {
        this.$message.warning('该嘉宾没有手机号码');
        return;
      }
      
      // 更新状态为发送中
      const index = this.smsListData.findIndex(i => i.guest._id === item.guest._id);
      if (index !== -1) {
        this.$set(this.smsListData[index], 'status', 'sending');
      }
      
      // 确认发送
      this.$confirm(`确定要向 ${item.guest.name} 发送短信吗？`, '确认发送', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 构建发送数据
        const sendData = {
          config: {
            ...this.smsConfig,
            content: item.content
          },
          guests: [{
            id: item.guest._id,
            name: item.guest.name,
            phone: item.guest.phone,
            schedules: item.guest.schedules,
            agendas: item.guest.agendas
          }]
        };
        
        // 调用API发送短信
        axios.post('/api/sms/send', sendData).then(response => {
          // 更新状态
          if (index !== -1) {
            if (response.data.status === '10000') {
              this.$set(this.smsListData[index], 'status', 'success');
              this.$message.success(`向 ${item.guest.name} 的短信发送成功`);
            } else {
              this.$set(this.smsListData[index], 'status', 'failed');
              this.$message.error(response.data.message || '发送失败');
            }
          }
        }).catch(err => {
          // 更新状态为失败
          if (index !== -1) {
            this.$set(this.smsListData[index], 'status', 'failed');
          }
          console.error('发送短信失败', err);
          this.$message.error('发送短信失败');
        });
      }).catch(() => {
        // 取消发送，恢复状态
        if (index !== -1) {
          this.$set(this.smsListData[index], 'status', 'pending');
        }
      });
    },
    
    sendAllSms() {
      // 筛选出有手机号且未发送成功的嘉宾
      const validItems = this.smsListData.filter(item => 
        item.guest.phone && 
        item.status !== 'success' && 
        item.status !== 'sending'
      );
      
      if (validItems.length === 0) {
        this.$message.warning('没有可发送的短信');
        return;
      }
      
      // 确认发送
      this.$confirm(`确定要向 ${validItems.length} 位嘉宾发送短信吗？`, '确认发送', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 更新所有要发送的项目状态为发送中
        validItems.forEach(item => {
          const index = this.smsListData.findIndex(i => i.guest._id === item.guest._id);
          if (index !== -1) {
            this.$set(this.smsListData[index], 'status', 'sending');
          }
        });
        
        // 构建发送数据
        const sendData = {
          config: this.smsConfig,
          guests: validItems.map(item => ({
            id: item.guest._id,
            name: item.guest.name,
            phone: item.guest.phone,
            content: item.content, // 每位嘉宾的个性化内容
            schedules: item.guest.schedules,
            agendas: item.guest.agendas
          }))
        };
        
        // 显示加载中
        const loading = this.$loading({
          lock: true,
          text: `正在发送短信 (0/${validItems.length})...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        // 调用API发送短信
        axios.post('/api/sms/batch-send', sendData).then(response => {
          loading.close();
          
          if (response.data.status === '10000') {
            const taskId = response.data.data?.taskId;
            this.$message.success(`批量短信发送任务已创建${taskId ? '（任务ID：' + taskId + '）' : ''}，正在后台处理`);
            // 异步任务：保持各项为 pending，等待后台处理
          } else {
            // 所有都标记为失败
            validItems.forEach(item => {
              const index = this.smsListData.findIndex(i => i.guest._id === item.guest._id);
              if (index !== -1) {
                this.$set(this.smsListData[index], 'status', 'failed');
              }
            });
            this.$message.error(response.data.message || '批量发送失败');
          }
        }).catch(err => {
          loading.close();
          // 所有都标记为失败
          validItems.forEach(item => {
            const index = this.smsListData.findIndex(i => i.guest._id === item.guest._id);
            if (index !== -1) {
              this.$set(this.smsListData[index], 'status', 'failed');
            }
          });
          console.error('批量发送短信失败', err);
          this.$message.error('批量发送短信失败');
        });
      }).catch(() => {
        // 取消发送，恢复所有状态
        validItems.forEach(item => {
          const index = this.smsListData.findIndex(i => i.guest._id === item.guest._id);
          if (index !== -1) {
            this.$set(this.smsListData[index], 'status', 'pending');
          }
        });
      });
    },
    // 保存短信配置
    saveSmsConfig() {
      if (!this.smsConfig.conferenceTitle) {
        this.$message.warning('请输入会议标题');
        return;
      }
      
      // if (!this.smsConfig.dateRange || this.smsConfig.dateRange.length < 2) {
      //   this.$message.warning('请选择日期范围');
      //   return;
      // }
      
      if (!this.smsConfig.city) {
        this.$message.warning('请输入城市');
        return;
      }
      
      // 准备要保存的数据
      const smsConfigData = {
        archiveId: this.archiveId,
        topBanner: this.smsConfig.topBanner,
        bottomBanner: this.smsConfig.bottomBanner,
        conferenceTitle: this.smsConfig.conferenceTitle,
        dateRangeText: this.smsConfig.dateRangeText,
        city: this.smsConfig.city,
        addressDetails: this.smsConfig.addressDetails || '',
        taskContact: this.smsConfig.taskContact || '',
        taskContactPhone: this.smsConfig.taskContactPhone || '',
        eventContact: this.smsConfig.eventContact || '',
        eventContactPhone: this.smsConfig.eventContactPhone || ''
      };
      
      // 显示加载中
      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      // 调用API保存短信配置
      axios.post('/api/sms/config/save', smsConfigData).then(response => {
        loading.close();
        
        if (response.data.status === '10000') {
          this.$message.success('短信配置保存成功');
          
          // 自动生成短信内容模板
          this.generateSmsTemplate();
        } else {
          this.$message.error(response.data.message || '保存失败');
        }
      }).catch(err => {
        loading.close();
        console.error('保存短信配置失败', err);
        this.$message.error('保存短信配置失败');
      });
    },
    
    // 加载短信配置
    loadSmsConfig() {
      if (!this.archiveId) return;
      
      // 显示加载中
      this.smsConfigLoading = true;
      
      // 调用API加载短信配置
      axios.get(`/api/sms/config?archiveId=${this.archiveId}`).then(response => {
        if (response.data.status === '10000' && response.data.data) {
          // 更新配置
          this.smsConfig = {
            ...this.smsConfig,
            ...response.data.data
          };
          
          // 生成短信内容模板
          this.generateSmsTemplate();
        }
      }).catch(err => {
        console.error('加载短信配置失败', err);
      }).finally(() => {
        this.smsConfigLoading = false;
      });
    },
    
    // 生成短信内容模板
    generateSmsTemplate() {
      // 生成新的短信内容模板，符合最新要求
      this.smsConfig.content = `微信搜索公众号：E健云，点击菜单“学术会议” 里的“我的信息”输入手机号获取您的活动安排。`;
    },
    
    confirmTemplateContent() {
      this.templatePreviewVisible = false;
      this.smsConfigContent = this.smsConfig.content;
    },
    // 生成短信内容，替换内容中的变量
    generateContent(guest, content, firstSchedule) {
      if (guest && content) {
        // 处理嘉宾ID和归档ID参数
        const guestId = guest._id || '';
        const archiveId = this.archiveId || '';

        // 处理会议标题
        const conferenceTitle = this.smsConfig.conferenceTitle || '';
        
        // 处理城市信息
        const city = this.smsConfig.city || '';
        
        // 处理时间，优先使用配置的日期范围
        const timeText = this.smsConfig.dateRangeText || (firstSchedule ? (firstSchedule.startTime || '') : '');

        content = content
          .replace(/\${name}/g, guest.name || '')
          .replace(/\${title}/g, conferenceTitle) // 新模板使用title代替conferenceTitle
          .replace(/\${time}/g, timeText) // 使用配置的日期范围文本
          .replace(/\${address}/g, city) // 使用配置的城市
          .replace(/\${address_details}/g, this.smsConfig.addressDetails || '')
          .replace(/\${link}/g, guestId)
          .replace(/\${link2}/g, archiveId)
          .replace(/\${name1}/g, this.smsConfig.taskContact || '')
          .replace(/\${contacts}/g, this.smsConfig.taskContactPhone || '')
          .replace(/\${name2}/g, this.smsConfig.eventContact || '')
          .replace(/\${contacts2}/g, this.smsConfig.eventContactPhone || '');
      }
      
      return content;
    },
    infoTips() {
      // 提示用户变量说明
      this.$notify({
        title: '变量说明',
        message: '短信内容支持以下变量：${name}（嘉宾姓名）、${position}（职位）、${title}（会议标题）、${time}（时间）、${address}（地点）、${address_details}（详细地址）、${name1}（任务联系人）、${contacts}（任务联系人电话）、${name2}（会务联系人）、${contacts2}（会务联系人电话）、${link}（嘉宾ID）、${link2}（归档ID）',
        duration: 0,
        type: 'info'
      });
      
      // 提示用户链接格式
      this.$message.info('短信模板中的${link}将被替换为嘉宾ID，${link2}将被替换为归档ID');
    },
    // 新增：处理嘉宾搜索
    handleGuestSearch() {
      this.currentPage = 1; // 搜索时回到第一页
      this.getGuestList();
    },
    filterSpecialChars(field) {
      // 正则表达式过滤特殊字符，只允许中文、英文、数字
      const regex = /[^\u4e00-\u9fa5a-zA-Z0-9]/g;
      this.smsConfig[field] = this.smsConfig[field].replace(regex, '');
    },
    // 下载模板
    async downloadTemplate() {
      try {
        this.$message.info('正在生成模板，请稍候...');
        
        const response = await axios.get('/api/schedule/export/template', {
          responseType: 'blob'
        });
        
        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `日程导入模板_${formatDate(new Date(), 'YYYYMMDD')}.xlsx`);
        document.body.appendChild(link);
        link.click();
        
        // 清理
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        
        this.$message.success('模板下载成功');
      } catch (error) {
        console.error('下载模板失败:', error);
        this.$message.error('下载模板失败，请重试');
      }
    },

    // 导出Excel
    async exportExcel() {
      if (!this.archiveId) {
        this.$message.warning('请先选择归档');
        return;
      }
      
      try {
        // 显示加载提示
        const loading = this.$loading({
          lock: true,
          text: '正在导出数据，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        const response = await axios.get(`/api/schedule/export/excel`, {
          params: {
            archiveId: this.archiveId,
            startDate: this.dateRange && this.dateRange[0] || undefined,
            endDate: this.dateRange && this.dateRange[1] || undefined,
            keyword: this.keywordSearch || undefined
          },
          responseType: 'blob'
        });
        
        // 关闭加载提示
        loading.close();
        
        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        // 生成文件名
        const fileName = `${this.archiveName || '日程'}_${formatDate(new Date(), 'YYYYMMDD_HHmmss')}.xlsx`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        
        // 清理
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        
        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请重试');
      }
    },

    // 上传相关方法
    handleBeforeUpload(file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                      file.type === 'application/vnd.ms-excel' ||
                      file.name.endsWith('.xlsx') ||
                      file.name.endsWith('.xls');
      
      if (!isExcel) {
        this.$message.error('只能上传 Excel 文件!');
        return false;
      }
      
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return false;
      }
      
      this.isUploading = true;
      this.uploadProgress = 0;
      return true;
    },

    handleUploadProgress(event) {
      this.uploadProgress = Math.round(event.percent);
    },

    async handleUploadSuccess(response, file) {
      this.isUploading = false;
      this.uploadProgress = 0;
      
      if (response.status === '10000') {
        // 显示导入结果
        const stats = response.data;
        const message = `导入完成！\n日程：成功 ${stats.schedules.success} 条，失败 ${stats.schedules.failed} 条\n议程：成功 ${stats.agendas.success} 条，失败 ${stats.agendas.failed} 条`;
        
        if (stats.schedules.failed > 0 || stats.agendas.failed > 0) {
          this.$alert(message, '导入结果', {
            confirmButtonText: '确定',
            type: 'warning',
            dangerouslyUseHTMLString: true
          });
        } else {
          this.$message.success(message);
        }
        
        // 如果有错误详情，显示错误信息
        if (response.data.errors && response.data.errors.length > 0) {
          console.error('导入错误详情:', response.data.errors);
          // 可以将错误信息显示在对话框中
          this.showImportErrors(response.data.errors);
        }
        
        // 刷新数据
        this.getScheduleMatrix();
      } else {
        this.$message.error(response.message || '导入失败');
      }
    },

    handleUploadError(err) {
      this.isUploading = false;
      this.uploadProgress = 0;
      console.error('上传失败:', err);
      this.$message.error('上传失败，请检查文件格式是否正确');
    },
    
    // 显示导入错误详情
    showImportErrors(errors) {
      const h = this.$createElement;
      const errorList = errors.slice(0, 10).map(err => 
        h('li', { style: 'margin-bottom: 5px;' }, `行${err.row}: ${err.message}`)
      );
      
      if (errors.length > 10) {
        errorList.push(h('li', `... 还有 ${errors.length - 10} 条错误`));
      }
      
      this.$alert(
        h('div', [
          h('p', { style: 'margin-bottom: 10px;' }, '以下数据导入失败：'),
          h('ul', { style: 'list-style: none; padding-left: 0;' }, errorList)
        ]),
        '导入错误详情',
        {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true
        }
      );
    },
    // Tab切换处理
    handleTabClick(tab) {
      console.log('切换到tab:', tab.name);
      if (tab.name === 'status') {
        this.$refs.smsTaskList.loadSmsTaskList();
      }
    },
    
    // 刷新任务列表
    refreshTaskList() {
      this.$refs.smsTaskList.loadSmsTaskList();
    },
    
    // 查看任务详情
    viewTaskDetails(task) {
      this.$router.push({
        path: '/mall/schedule/sms-task-detail',
        query: {
          taskId: task.taskId,
          archiveId: task.archiveId
        }
      });
    },
    
    // 取消任务
    async cancelTask(task) {
      this.$refs.smsTaskList.loadSmsTaskList();
    },
    
    // 获取任务状态类型
    getTaskStatusType(taskStatus) {
      const statusMap = {
        pending: 'info',
        processing: 'warning', 
        completed: 'success',
        cancelled: 'danger'
      };
      return statusMap[taskStatus] || 'info';
    },
    
    // 获取任务状态文本
    getTaskStatusText(taskStatus) {
      const statusMap = {
        pending: '待处理',
        processing: '处理中',
        completed: '已完成',
        cancelled: '已取消'
      };
      return statusMap[taskStatus] || '未知';
    },
    
    // 计算进度百分比
    getProgressPercentage(statistics) {
      if (!statistics || statistics.total === 0) return 0;
      const completed = statistics.sent + statistics.failed;
      return Math.round((completed / statistics.total) * 100);
    },
    
    // 获取进度状态
    getProgressStatus(taskStatus) {
      if (taskStatus === 'completed') return 'success';
      if (taskStatus === 'cancelled') return 'exception';
      return null;
    },
    
    // 格式化日期时间
    formatDateTime(date) {
      if (!date) return '';
      return formatDate(new Date(date), 'YYYY-MM-DD HH:mm:ss');
    },
    handleViewTaskDetails(task) {
      this.$router.push({
        path: '/mall/schedule/sms-task-detail',
        query: {
          taskId: task.taskId,
          archiveId: task.archiveId
        }
      })
    },
    
    // 取消任务
    async handleCancelTask(task) {
      try {
        await this.$confirm('确定要取消这个发送任务吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await request.post('/sms/task/cancel', {
          taskId: task.taskId
        })
        
        if (response.status === '10000') {
          this.$message.success('任务已取消')
          this.$refs.smsTaskList.loadTaskList()
        } else {
          this.$message.error(response.message || '取消任务失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消任务失败:', error)
          this.$message.error('取消任务失败')
        }
      }
    },
    
    // 添加弹窗关闭处理方法
    handleSmsDialogClosed() {
      try {
        // 子组件会因 destroy-on-close 自行清理，父组件无需干预
        // 确保主组件自身的轮询停止
        this.stopPolling();
        
        // 只重置父组件自身的状态
        this.activeTab = 'config';
        this.selectedGuests = [];
        this.guestSearchKeyword = '';
        this.smsListData = [];
        this.guestList = [];
        
        console.log('短信弹窗已关闭，父组件状态已重置。');
      } catch (error) {
        console.error('关闭弹窗时清理资源出错:', error);
      }
    },
    handleExcelChange(file, fileList) {
      this.excelFileList = fileList;
      this.canProceed = fileList.length > 0;
    },
    async nextStep() {
      if (this.importStep === 0) {
        // 步骤1：上传文件 -> 数据预览
        await this.parseExcelFile();
      } else if (this.importStep === 1) {
        // 步骤2：数据预览 -> 开始导入
        await this.startImport();
      }
    },
    cancelImport() {
      this.importDialogVisible = false;
      this.importStep = 0;
      this.importing = false;
      this.canProceed = false;
      this.previewData = {
        schedules: { total: 0, valid: 0 },
        agendas: { total: 0, valid: 0 },
        errors: [],
        guestResolution: { createdGuests: [], createdCategories: [], ambiguous: [] }
      };
      this.importResult = {
        success: false,
        message: '',
        data: {
          schedules: { success: 0, failed: 0 },
          agendas: { success: 0, failed: 0 },
          guestResolution: { createdGuests: [], createdCategories: [], ambiguous: [] }
        }
      };
      this.excelFileList = [];
    },

    // 打开导入对话框
    openImportDialog() {
      this.importDialogVisible = true;
      this.importStep = 0;
      this.importing = false;
      this.canProceed = false;
      this.excelFileList = [];
    },

    // 导出模板（用于导入对话框）
    async exportTemplate() {
      try {
        this.$message.info('正在生成模板，请稍候...');
        
        const response = await axios.get('/api/schedule/export/template', {
          responseType: 'blob'
        });
        
        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `日程导入模板_${formatDate(new Date(), 'YYYYMMDD')}.xlsx`);
        document.body.appendChild(link);
        link.click();
        
        // 清理
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        
        this.$message.success('模板下载成功');
      } catch (error) {
        console.error('下载模板失败:', error);
        this.$message.error('下载模板失败，请重试');
      }
    },

    // 解析Excel文件
    async parseExcelFile() {
      if (!this.excelFileList || this.excelFileList.length === 0) {
        this.$message.warning('请先选择Excel文件');
        return;
      }

      try {
        const formData = new FormData();
        formData.append('file', this.excelFileList[0].raw);
        formData.append('archiveId', this.archiveId);

        // 调用后端API进行文件解析和预览
        const response = await axios.post('/api/schedule/import/preview', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.status === '10000') {
          // 兜底 guestResolution，避免后端未返回该字段时模板访问报错
          this.previewData = {
            guestResolution: { createdGuests: [], createdCategories: [], ambiguous: [] },
            ...response.data.data
          };
          this.importStep = 1;
        } else {
          this.$message.error(response.data.message || '文件解析失败');
        }
      } catch (error) {
        console.error('文件解析失败:', error);
        this.$message.error('文件解析失败，请检查文件格式');
      }
    },

    // 开始导入
    async startImport() {
      if (!this.excelFileList || this.excelFileList.length === 0) {
        this.$message.warning('请先选择Excel文件');
        return;
      }

      this.importing = true;

      try {
        const formData = new FormData();
        formData.append('file', this.excelFileList[0].raw);
        formData.append('archiveId', this.archiveId);

        const response = await axios.post('/api/schedule/import/excel', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.status === '10000') {
          this.importResult = {
            success: true,
            message: '导入成功完成',
            data: {
              guestResolution: { createdGuests: [], createdCategories: [], ambiguous: [] },
              ...response.data.data
            }
          };
          
          // 导入成功后刷新数据
          this.getScheduleMatrix();
        } else {
          this.importResult = {
            success: false,
            message: response.data.message || '导入失败',
            data: {
              schedules: { success: 0, failed: 0 },
              agendas: { success: 0, failed: 0 }
            }
          };
        }
      } catch (error) {
        console.error('导入失败:', error);
        this.importResult = {
          success: false,
          message: '导入失败，请检查文件格式',
          data: {
            schedules: { success: 0, failed: 0 },
            agendas: { success: 0, failed: 0 }
          }
        };
      }

      this.importing = false;
      this.importStep = 2;
    }
  }
}
</script>

<style lang="scss" scoped>
.schedule-container {
  padding: 20px;
  background-color: #f5f7fa;
  height: calc(100vh - 84px);
  overflow-y: auto;
}

.schedule-header {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.schedule-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.schedule-content {
  background-color: #fff;
  border-radius: 4px;
  
  .el-card {
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05) !important;
  }
}

.filter-container {
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.filter-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .el-input, .el-date-picker {
    margin-right: 15px;
    margin-bottom: 10px;
  }
}

.filter-right {
  display: flex;
  margin-bottom: 10px;
  
  .el-button {
    margin-left: 10px;
  }
}

.empty-block {
  padding: 40px 0;
  text-align: center;
}

.empty-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.schedule-matrix {
  overflow-x: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin-bottom: 20px; /* 确保底部有足够空间 */
  
  .matrix-header {
    background-color: #f5f7fa;
    font-weight: 500;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    width: fit-content;
    min-width: 100%;
    position: sticky; /* 确保表头粘性定位 */
    top: 0;
    z-index: 3;
  }
  
  .matrix-body {
    width: fit-content;
    min-width: 100%;
  }
  
  .matrix-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;
    min-height: 80px; /* 改为最小高度而非固定高度 */
    
    &:last-child {
      border-bottom: none;
    }
  }
  
  .matrix-cell {
    border-right: 1px solid #ebeef5;
    min-height: 80px;
    word-break: break-all;
    
    &.venue-header, &.date-header {
      position: sticky;
      left: 0;
      z-index: 2;
      background-color: #f5f7fa;
      font-weight: 500;
      height: 60px; /* 保持表头固定高度 */
    }
    
    &.venue-header {
      min-width: 160px;
      width: 160px;
    }
    
    &.date-header {
      min-width: 180px;
      width: 180px;
      padding: 10px;
    }
    
    &.venue-name {
      min-width: 160px;
      width: 160px;
      padding: 10px;
      font-weight: 500;
      min-height: 80px; /* 改为最小高度而非固定高度 */
      display: flex;
      flex-direction: column;
      justify-content: center;
      
      .venue-thumbnail {
        margin-top: 5px;
        width: 50px;
        height: 50px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #ebeef5;
        
        .venue-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    
    &.content-cell {
      min-width: 180px;
      width: 180px;
      min-height: 80px; /* 改为最小高度而非固定高度 */
      height: auto; /* 允许自动增长 */
      overflow-y: visible; /* 改为可见，而非滚动 */
      padding: 8px; /* 增加内边距 */
      
      .cell-content {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }
    
    &:last-child {
      border-right: none;
    }
  }
  
  .date-header {
    padding: 10px;
    background-color: #f5f7fa;
    
    .font-medium {
      font-size: 14px;
      margin-bottom: 4px;
    }
    
    .text-xs {
      font-size: 12px;
      color: #606266;
    }
  }
  
  .schedule-item {
    padding: 8px 10px;
    margin-bottom: 6px;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: #fff;
    border: 1px solid #ebeef5;
    position: relative;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border-color: #409EFF;
      
      .schedule-title:after {
        content: " 🔍";
        opacity: 0.7;
        font-size: 12px;
      }
      
      .schedule-item-actions {
        opacity: 1;
        right: 5px;
      }
    }
    
    &:last-child {
      margin-bottom: 8px; /* 确保最后一个项目和添加按钮之间有间距 */
    }
    
    &.is-disabled {
      opacity: 0.6;
      background-color: #f5f7fa;
    }
    
    .schedule-title {
      font-weight: 500;
      font-size: 13px;
      margin-bottom: 5px;
      color: #303133;
      word-break: break-word;
    }
    
    .schedule-time {
      font-size: 12px;
      color: #606266;
    }
    
    .schedule-agenda-count {
      margin-top: 5px;
      font-size: 12px;
      
      .el-tag {
        padding: 0 6px;
        height: 20px;
        line-height: 18px;
        font-size: 10px;
        background-color: #f4f4f5;
        color: #909399;
        border-color: #e9e9eb;
      }
    }
    
    .schedule-item-actions {
      position: absolute;
      top: 50%;
      right: -30px;
      transform: translateY(-50%);
      opacity: 0;
      transition: all 0.2s ease;
      
      .el-button {
        padding: 4px;
        font-size: 12px;
      }
    }
  }
  
  .empty-cell {
    min-height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.6;
    transition: opacity 0.2s;
    height: 100%;
    
    &:hover {
      opacity: 1;
      background-color: #f8f9fb;
    }
    
    .el-button {
      font-size: 12px;
    }
  }
  
  .add-schedule-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    opacity: 0.7;
    transition: opacity 0.2s, background-color 0.2s;
    border-radius: 4px;
    margin-top: 8px; /* 确保与日程项之间有间距 */
    margin-bottom: 4px; /* 确保底部有间距 */
    
    &:hover {
      opacity: 1;
      background-color: #f0f2f5;
    }
    
    &.mt-2 {
      margin-top: 8px;
    }
    
    .el-button {
      font-size: 12px;
      padding: 4px 8px;
    }
  }
}

/* 自定义加载骨架屏 */
.loading-skeleton {
  width: 100%;
  padding: 20px;
}

.skeleton-row {
  height: 20px;
  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  margin-bottom: 15px;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* 优化表单弹窗样式 */
::v-deep .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
}

::v-deep .el-dialog__body {
  padding: 20px;
}

::v-deep .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
}

/* Tailwind类替换 */
.mb-4 {
  margin-bottom: 16px;
}

.w-48 {
  width: 192px;
}

.mr-4 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 8px;
}

.w-80 {
  width: 320px;
}

.w-full {
  width: 100%;
}

.py-8 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.min-w-28 {
  min-width: 112px;
}

.min-w-48 {
  min-width: 192px;
}

.p-2 {
  padding: 8px;
}

.text-xs {
  font-size: 12px;
}

.text-gray-500 {
  color: #909399;
}

.mt-1 {
  margin-top: 4px;
}

.border-b {
  border-bottom: 1px solid #ebeef5;
}

.border-r {
  border-right: 1px solid #ebeef5;
}

.bg-gray-100 {
  background-color: #f5f7fa;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.ml-2 {
  margin-left: 8px;
}

.mt-4 {
  margin-top: 16px;
}

.font-medium {
  font-weight: 500;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mr-2 {
  margin-right: 8px;
}

.bg-gray-50 {
  background-color: #f9fafc;
}

.h-full {
  height: 100%;
}

.info-box {
  padding: 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.5;
}

.p-3 {
  padding: 12px;
}

.mb-3 {
  margin-bottom: 12px;
}

.rounded {
  border-radius: 4px;
}

.filter-tabs {
  margin-bottom: 20px;
}

.filter-group {
  margin-bottom: 16px;
  border-bottom: 1px dashed #ebeef5;
  padding-bottom: 12px;
  
  &:last-child {
    border-bottom: none;
  }
}

.filter-label {
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  margin-bottom: 8px;
  width: 50px;
  display: inline-block;
}

.filter-options {
  display: inline-block;
  
  .el-button {
    margin-right: 8px;
    margin-bottom: 8px;
  }
}

.filter-button-wrapper {
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-right: 8px;
  margin-bottom: 8px;
  
  &:hover {
    .filter-button-actions {
      display: flex;
    }
  }
  
  .el-button {
    margin-right: 0;
  }
}

.filter-button-actions {
  display: none;
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 2px;
  z-index: 10;
  
  .action-btn {
    padding: 4px;
    margin: 0 2px;
    font-size: 16px;
    color: #409EFF;
    
    &.delete-btn {
      color: #F56C6C;
    }
    
    &:hover {
      background-color: #f5f7fa;
    }
  }
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
  
  .el-icon-info {
    margin-right: 4px;
    color: #E6A23C;
  }
}

.image-upload-container {
  width: 100%;
  
  .image-preview {
    position: relative;
    width: 180px;
    height: 180px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    
    &:hover .image-actions {
      opacity: 1;
    }
    
    .preview-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    .image-actions {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0;
      transition: opacity 0.3s;
      
      i {
        font-size: 24px;
        color: #fff;
      }
    }
  }
  
  .upload-placeholder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 180px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    background-color: #fafafa;
    cursor: pointer;
    transition: border-color 0.3s;
    
    &:hover {
      border-color: #409EFF;
    }
    
    i {
      font-size: 28px;
      color: #8c939d;
      margin-bottom: 8px;
    }
    
    div {
      font-size: 12px;
      color: #606266;
      text-align: center;
      padding: 0 10px;
      line-height: 1.5;
    }
  }
}

.editor-container {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  min-height: 200px;
  margin-bottom: 10px;
}

.banner-uploader {
  width: 100%;
  cursor: pointer;
}

.banner-image {
  width: 100%;
  max-height: 400px;
  object-fit: contain;
  display: block;
}

.banner-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 360px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.upload-tip {
  font-size: 12px;
  color: #606266;
  margin-top: 5px;
}

.schedule-detail-dialog {
  .el-dialog__body {
    padding: 20px;
  }
  
  .subtitle {
    font-size: 14px;
    color: #606266;
    padding-bottom: 16px;
    border-bottom: 1px solid #EBEEF5;
  }
  
  .info-item {
    margin-bottom: 12px;
    line-height: 32px;
    
    .info-label {
      width: 60px;
      color: #909399;
      font-size: 14px;
    }
    
    .info-value {
      font-size: 14px;
      color: #303133;
    }
  }
  
  .min-w-20 {
    min-width: 50px;
  }
}

.detail-header {
  text-align: center;
  margin-bottom: 20px;
}

.time-block {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.detail-section {
  margin-bottom: 20px;
}

.guests-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.guest-card {
  background-color: #fff;
  border-radius: 4px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: calc(25% - 16px);
  box-sizing: border-box;
}

.venue-info {
  text-align: center;
  margin-bottom: 16px;
}

.rich-text-content {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 16px;
}

.sms-dialog {
  .el-dialog__body {
    padding: 20px;
  }
}

.sms-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.sms-config-section {
  margin-bottom: 20px;
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .upload-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
  }
}

.banner-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    
    &:hover {
      border-color: #409EFF;
    }
  }
  
  .banner-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  
  .banner-image {
    width: 178px;
    height: 100px;
    display: block;
    object-fit: cover;
  }
}

.sms-preview-container {
  height: 600px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #f5f7fa;
  
  .sms-preview-frame {
    width: 100%;
    height: 100%;
    border: none;
  }
  
  .sms-preview-placeholder {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
  }
}

.sms-preview-dialog {
  .el-dialog__body {
    padding: 20px;
    max-height: 70vh;
  }
  
  .sms-preview-container {
    height: 60vh;
  }
}

.guest-list-section {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .guest-schedule-item, .guest-agenda-item {
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
    background-color: #f5f7fa;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .guest-schedule-item {
    border-left: 3px solid #409EFF;
  }
  
  .guest-agenda-item {
    border-left: 3px solid #67C23A;
  }
  
  .schedule-title, .agenda-title {
    font-weight: 500;
    margin-bottom: 5px;
    font-size: 14px;
  }
  
  .schedule-info, .agenda-info {
    font-size: 12px;
    color: #606266;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }
  
  .empty-text {
    padding: 20px 0;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }
  
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}

// 工具类
.mr-2 {
  margin-right: 8px;
}

.mr-3 {
  margin-right: 12px;
}

.mr-4 {
  margin-right: 16px;
}

.ml-2 {
  margin-left: 8px;
}

.mt-1 {
  margin-top: 4px;
}

.mt-4 {
  margin-top: 16px;
}

.mb-4 {
  margin-bottom: 16px;
}

.w-64 {
  width: 256px;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.items-start {
  align-items: flex-start;
}

.justify-between {
  justify-content: space-between;
}

.font-medium {
  font-weight: 500;
}

.text-xs {
  font-size: 12px;
}

.text-gray-500 {
  color: #909399;
}

.sms-preview-dialog {
  .el-dialog__body {
    padding: 20px;
  }
}

.form-helper-text {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.sms-content-editor {
  margin-bottom: 10px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 15px;
  background-color: #fff;
}

.sms-template {
  margin-bottom: 15px;
  line-height: 2;
}

.inline-input {
  width: 100px;
  margin: 0 5px;
}

.inline-input :deep(.el-input__inner) {
  border: none;
  border-bottom: 1px dashed #409EFF;
  border-radius: 0;
  padding: 0 5px;
  text-align: center;
  background-color: rgba(64, 158, 255, 0.05);
}

.inline-input :deep(.el-input__inner:focus) {
  border-bottom: 1px solid #409EFF;
}

.form-actions {
  margin-bottom: 10px;
}

.generated-content {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px dashed #EBEEF5;
}

.content-label {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}

.sms-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.guest-sms-preview {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.guest-info-card {
  display: flex;
  align-items: center;
}

.guest-avatar {
  margin-right: 16px;
}

.guest-details {
  display: flex;
  flex-direction: column;
}

.guest-name {
  font-size: 16px;
  font-weight: 500;
}

.guest-position, .guest-company {
  font-size: 14px;
  color: #606266;
}

.guest-phone {
  font-size: 14px;
  color: #909399;
}

.sms-content-preview {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 16px;
}

.preview-label {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 8px;
}

.preview-content {
  display: flex;
  flex-direction: column;
}

.banner-preview {
  margin-bottom: 16px;
}

.banner-image-preview {
  width: 100%;
  max-height: 200px;
  object-fit: contain;
}

.contact-info-preview {
  font-size: 14px;
  color: #606266;
}

.sms-list-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.sms-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.sms-list-title {
  font-size: 16px;
  font-weight: 500;
}

.sms-list-actions {
  display: flex;
}

.sms-item-actions {
  display: flex;
  align-items: center;
}

.sms-content-card {
  flex: 1;
  padding: 10px;
  background-color: #f9fafc;
  border-radius: 4px;
}

.content-text {
  font-size: 14px;
  color: #303133;
}

.variable-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.variable-label {
  font-size: 12px;
  color: #606266;
}

.variable-value {
  font-size: 14px;
  color: #303133;
}

.template-preview-content {
  padding: 20px;
}

.sms-config-fields {
  margin-bottom: 15px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 15px;
  background-color: #fff;
}

.sms-config-fields .el-form-item {
  margin-bottom: 15px;
}

.date-range-picker {
  width: 100%;
}

.template-preview-content {
  padding: 20px;
}

/* 添加上传相关样式 */
.el-upload {
  display: inline-block;
  margin: 0 8px;
}

.el-progress {
  width: 100%;
  margin-bottom: 16px;
}

/* 添加上传相关样式 */
.import-upload-wrapper {
  display: inline-block;
  vertical-align: top;
}

.inline-upload {
  display: inline-block;
}

.inline-upload .el-upload {
  display: inline-block;
  vertical-align: top;
  margin: 0 !important;
}

.filter-right {
  gap: 8px;
}

.filter-right .el-button {
  white-space: nowrap;
  flex-shrink: 0;
}

.el-upload {
  display: inline-block;
}

.el-progress {
  width: 100%;
  margin-bottom: 16px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .filter-container {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filter-left,
  .filter-right {
    width: 100%;
    justify-content: flex-start;
  }
  
  .filter-right {
    margin-top: 10px;
  }
}

/* 导入导出按钮相关样式 */
.filter-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.action-btn {
  margin: 0 !important;
  white-space: nowrap;
  flex-shrink: 0;
}

.import-export-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.upload-component {
  display: inline-flex;
  align-items: center;
  margin: 0;
}

.upload-component .el-upload {
  display: inline-block;
  margin: 0 !important;
}

.upload-component .el-button {
  margin: 0 !important;
}

.el-progress {
  width: 100%;
  margin-bottom: 16px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .filter-container {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filter-left,
  .filter-right {
    width: 100%;
    justify-content: flex-start;
  }
  
  .filter-right {
    margin-top: 10px;
    gap: 8px;
  }
  
  .import-export-group {
    width: 100%;
    justify-content: flex-start;
    gap: 12px;
  }
}

/* 导入导出按钮及相关布局的特定样式 */
.filter-right {
  display: flex;
  align-items: center;
  gap: 16px; /* 主容器中各项（刷新、短信、导入导出组）之间的间距 */
  flex-wrap: wrap;
}

.action-btn {
  margin: 0; /* 清除按钮自身外边距，依赖父级gap */
  white-space: nowrap;
  flex-shrink: 0;
}

.import-export-group {
  display: flex;
  align-items: center;
  gap: 16px; /* 组内按钮（下载、导入、导出）之间的间距，与主容器对齐 */
  flex-wrap: wrap;
  /* 可选：添加一些视觉包裹样式，如果需要 */
  /* padding: 4px 8px; */
  /* background-color: #f8f9fa; */
  /* border-radius: 6px; */
  /* border: 1px solid #e9ecef; */
}

.upload-component {
  display: inline-flex; /* 使el-upload组件本身成为一个flex项 */
  align-items: center; /* 垂直居中其内部内容（el-button）*/
  margin: 0; /* 清除外边距 */
}

/* 确保el-upload内的按钮也遵循action-btn的规则（如果已应用） */
.upload-component .el-button {
  margin: 0; /* 确保内部按钮也没有额外边距 */
}

/* 响应式布局调整 */
@media (max-width: 768px) {
  .filter-container { /* 假设是.filter-right的父级，用于整体换行 */
    flex-direction: column;
    align-items: stretch;
  }
  
  .filter-left,
  .filter-right {
    width: 100%;
    justify-content: flex-start; /* 在换行后靠左对齐 */
  }
  
  .filter-right {
    margin-top: 10px; /* 与上方.filter-left的间距 */
    gap: 12px; /* 在小屏幕上，主容器各项间距可略小 */
  }
  
  .import-export-group {
    width: 100%; /* 如果换行，则占满整行 */
    justify-content: flex-start;
    gap: 12px; /* 在小屏幕上，组内按钮间距也相应调整 */
  }
}

/* 导入导出按钮及相关布局的特定样式 */
.filter-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.action-btn {
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

.upload-component {
  display: inline-flex;
  align-items: center;
  margin: 0;
}

.upload-component .el-button {
  margin: 0;
}

/* 为导出Excel按钮（紧跟在导入组件之后）添加额外的左边距 */
.upload-component + .action-btn {
  margin-left: 16px;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
  .filter-container {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-left,
  .filter-right {
    width: 100%;
    justify-content: flex-start;
  }

  .filter-right {
    margin-top: 10px;
    gap: 12px;
  }
}

/* 导入导出按钮及相关布局的特定样式 */
.filter-right {
  display: flex;
  align-items: center; /* Vertical alignment of items on the same line */
  gap: 16px; /* Default gap between all direct children */
  flex-wrap: wrap; /* Allow items to wrap to the next line */
}

.action-btn { /* Common style for all buttons */
  margin: 0;
  white-space: nowrap; /* Prevent button text from wrapping */
  flex-shrink: 0; /* Prevent buttons from shrinking if space is tight */
}

.upload-component { /* Styles for the <el-upload> component itself */
  display: inline-flex; /* Behaves like an inline element but lays out content using flexbox */
  align-items: center; /* Vertically align the button inside the upload slot */
  margin: 0; /* No self-margin, rely on parent's gap for space *before* it */
  flex-shrink: 0; /* Prevent the upload component itself from shrinking */
  margin-right: 60px; /* Explicitly add space *after* the upload component */
}

.upload-component .el-button { /* The button slotted into <el-upload> */
  margin: 0; /* Ensure no margin on the inner button */
}

/* 响应式布局调整 */
@media (max-width: 768px) {
  .filter-container { /* Parent of .filter-right */
    flex-direction: column;
    align-items: stretch;
  }

  .filter-left,
  .filter-right {
    width: 100%;
    justify-content: flex-start; /* Align items to the start when wrapped */
  }

  .filter-right {
    margin-top: 10px; /* Space between filter-left and filter-right when wrapped */
    gap: 12px; /* Smaller gap between items in .filter-right on mobile */
  }
  
  .upload-component {
    margin-right: 12px; /* Adjust margin-right for mobile if parent gap is also 12px */
  }
}

// 统计卡片样式
.statistics-cards {
  .stat-card {
    text-align: center;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    
    .stat-number {
      font-size: 24px;
      font-weight: bold;
      color: #333;
      margin-bottom: 5px;
    }
    
    .stat-label {
      font-size: 12px;
      color: #666;
    }
  }
}

// 进度信息样式
.progress-info {
  .progress-text {
    font-size: 12px;
    color: #606266;
    margin-bottom: 5px;
  }
}

// 短信状态区域样式
.sms-status-section {
  .mb-4 {
    margin-bottom: 16px;
  }
}

// 工具类样式
.mb-3 {
  margin-bottom: 12px;
}

.toolbar-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.toolbar-actions .el-button {
  white-space: nowrap;
  flex-shrink: 0;
}

.excel-uploader {
  margin-top: 10px;
}

.import-tips {
  margin-bottom: 10px;
}

.preview-stats {
  margin-bottom: 20px;
}

.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 12px;
  color: #606266;
}

.stat-value {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.success {
  color: #67C23A;
}

.error-list {
  margin-top: 10px;
}

.import-result {
  margin-top: 20px;
}

.result-stats {
  text-align: center;
}

.import-form {
  margin-top: 20px;
}

.import-form .el-form-item {
  margin-bottom: 10px;
}

.import-form .el-input {
  width: 100%;
}

.import-form .el-button {
  width: 100%;
}

/* 主题设置样式 */
.theme-preview {
  padding: 12px 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  margin-left: 12px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

::v-deep .el-radio__input.is-checked + .el-radio__label .theme-preview {
  border-color: #409eff;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

.theme-name {
  font-weight: 600;
  font-size: 15px;
  color: #303133;
  margin-bottom: 6px;
}

.theme-desc {
  font-size: 13px;
  color: #606266;
  line-height: 1.4;
}

.theme-preview-box {
  border: 2px solid #e4e7ed;
  border-radius: 12px;
  padding: 24px;
  background: #fff;
  min-height: 150px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.theme-preview-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  opacity: 0.1;
  z-index: 0;
}

.theme-preview-box.theme-default {
  border-color: #667eea;
  background: linear-gradient(135deg, #f5f3ff 0%, #e8e3ff 100%);
}

.theme-preview-box.theme-default::before {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.theme-preview-box.theme-modern {
  border-color: #2c3e50;
  background: linear-gradient(135deg, #f8f9fa 0%, #ecf0f1 100%);
}

.theme-preview-box.theme-modern::before {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}

.theme-preview-box.theme-elegant {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #f0f4f8 0%, #dbeafe 100%);
}

.theme-preview-box.theme-elegant::before {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
}

.preview-header {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 1;
}

.preview-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  z-index: 1;
}

.preview-schedule {
  padding: 14px 18px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.95);
  border-left: 4px solid #409eff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.preview-schedule:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.theme-preview-box.theme-default .preview-schedule {
  border-left-color: #667eea;
  background: rgba(255, 255, 255, 0.98);
}

.theme-preview-box.theme-modern .preview-schedule {
  border-left-color: #2c3e50;
  background: rgba(255, 255, 255, 0.98);
}

.theme-preview-box.theme-elegant .preview-schedule {
  border-left-color: #3b82f6;
  background: rgba(255, 255, 255, 0.98);
}

.schedule-title {
  font-weight: bold;
  color: #303133;
  margin-bottom: 4px;
}

.schedule-time {
  font-size: 12px;
  color: #606266;
}

/* 主题应用样式 */
.schedule-theme-default {
  /* 默认主题样式 */
}

.schedule-theme-business {
  /* 商务主题样式 */
}

.schedule-theme-tech {
  /* 科技主题样式 */
}
</style>